import React, { useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import html2canvas from "html2canvas";
import {
  Row,
  Col,
  Card,
  Button,
  Input,
  Divider,
  Space,
  Modal,
  InputNumber,
  Checkbox,
  Tabs,
  Form,
  Badge,
  Spin,
} from "antd";
import Title from "antd/es/typography/Title";
import {
  MinusCircleFilled,
  PlusCircleFilled,
  ExclamationCircleOutlined,
  EditOutlined,
  LogoutOutlined, 
  DeleteOutlined,
} from "@ant-design/icons";
import AddBoxIcon from '@mui/icons-material/AddBox';
import HomeIcon from "@mui/icons-material/Home";
import PaidIcon from "@mui/icons-material/Paid";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import WidgetsIcon from "@mui/icons-material/Widgets";

import { EditNoteOutlined } from "@mui/icons-material";

import toast from "react-hot-toast";
// import { UseGetRequest } from "../../utils/api/ApiRequests";
import { UseGetRequest } from "../../Helpers/hooks/GetRequests";
import {
  usePostRequest,
  usePutRequest,
} from "../../Helpers/hooks/usePostRequest";
import { UsePostRequest } from "../../Helpers/hooks/UsePostApiCall";
import {
  getToken,
  getUser,
  getRole,
  refreshPage,
  getRestoLogin,
  formatAmount,
  getFullNameUser,
  removeUserSession,
  isEmptyString,
  getProductShow,
  getSelectedTable,
  getFoodServer,
  getIsPaxCount,
  getIsAttending,
  getOrderShow,
  // getAttendingTransfer,
  getShowAddItem,
} from "../../Helpers/Utils/Common";
import { recordUserActivityLog } from "../../Helpers/apiCalls/authApi";
import {
  printBase64,
  printBase64Bulk,
  printOpenCashDrawer,
} from "../../Helpers/apiCalls/paymentAPI";
import DispatchSlip from "../../Components/Print/DispatchSlip";
import AuthenticationModal from "../../Components/Modals/AuthenticationModal";
import "../../cssFiles/MenuCategory.css";
import "../../cssFiles/CommonOrdering.css";
import "./Ordering.css";
import { logoutUser } from "../../Helpers/apiCalls/authApi";
import TextArea from "antd/es/input/TextArea";
import moment from "moment";

const priceTypes = ["store", "takeout", "delivery", "foodpanda", "grab"];

export default function Ordering() {
  const loggedInResto = getRestoLogin();
  const localOrderShow = getOrderShow();
  const localOpenPaxCount = getIsPaxCount();
  const localIsAttending = getIsAttending();
  const localFetchFoodServer = getFoodServer();
  const localFetchSelectedTable = getSelectedTable();
  // const localAttendingTransfer= getAttendingTransfer();
  
  const localShowAddItem = getShowAddItem() || false;
  const localShowProducts = getProductShow() || false;

  const userRole = getRole();
  const tabDefaultValue = loggedInResto ==="hanamaruken" ?"hanamaruken" : "ettas"; // SO WEIRD THE DEFAULT VALUES WORKS ONLY IF I DO THIS
  const { callPost, responseData, isLoading } = usePostRequest(() => {});
  const { callPut, putResponseData, putIsLoading } = usePutRequest(() => {});
  const [modal, contextHolder] = Modal.useModal();
  const transferRef = useRef();
  const dispatchRef = useRef();
  // const orderRef = useRef();
  const billOutRef = useRef();
  const voidRef = useRef();
  const cancelRef = useRef();
  const splitRef = useRef();
  const bulkPrintRefs = useRef([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [allTables, setAllTables] = useState({});
  const [allProducts, setAllProducts] = useState({});
  const [allCategories, setAllCategories] = useState([]);
  const [briqueCategories, setBriqueCategories] = useState([]);
  const [allBriqueProducts, setAllBriqueProducts] = useState({});
  // const [ettasCategories, setEttasCategories] = useState([]);
  // const [allEttasProducts, setAllEttasProducts] = useState({});
  const [selectedCategory, setSelectedCategory] = useState("");
  const [priceType, setPriceType] = useState("store");
  const [selectedTable, setSelectedTable] = useState(localFetchSelectedTable || {});
  const [selectedOrder, setSelectedOrder] = useState({});
  const [orderCart, setOrderCart] = useState([]);
  const [openModifier, setOpenModifier] = useState(false);
  const [modifierData, setModifierData] = useState([]);
  const [modifierOrder, setModifierOrder] = useState({
    counter: 0,
    modifier: [],
  });
  const [foodServer, setFoodServer] = useState(localFetchFoodServer ?? "");
  const [openPaxCountModal, setOpenPaxCountModal] = useState(localOpenPaxCount ?? false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [paxCount, setPaxCount] = useState(1);
  const [dispatchCounter, setDispatchCounter] = useState(null);
  const [action, setAction] = useState("order");
  const [dispatchItems, setDispatchItems] = useState([]);
  const [orderSlips, setOrderSlips] = useState({});
  const [cancelSlips, setCancelSlips] = useState({});
  const [voidSlips, setVoidSlips] = useState({});
  const [orderItems, setOrderItems] = useState([]);
  // const [showAddItem, setShowAddItem] = useState(localShowAddItem || false);
  const [additionalItems, setAdditionalItems] = useState([]);
  const [noBarAdditionalItems, setNoBarAdditionalItems] = useState([]);
  const [recipientTable, setRecipientTable] = useState({});
  const [openPaxErrorCountModal, setOpenPaxErrorCountModal] = useState(false);
  // const [showProductOptions, setShowProductOptions] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [itemsToVoid, setItemsToVoid] = useState([]); // items selected for voiding oe splitting
  const [voidedItems, setVoidedItems] = useState([]);
  const [tableIdToMerge, setTableIdToMerge] = useState([]);
  const [tablesToMerge, setTablesToMerge] = useState([]);
  const [openReprintModal, setOpenReprintModal] = useState(false);
  const [openVoidModal, setOpenVoidModal] = useState(false);
  const [openSplitModal, setOpenSplitModal] = useState(false);
  const [openMergeModal, setOpenMergeModal] = useState(false);
  const [openTransferModal, setOpenTransferModal] = useState(false);
  const [openTransferTableOptions, setOpenTransferTableOptions] =
    useState(false);
  const [openTransferItemOptions, setOpenTransferItemOptions] = useState(false);
  const [openAuthentication, setOpenAuthentication] = useState(false);
  const [mergedTables, setMergedTables] = useState([]);
  const [reason, setReason] = useState("");
  const [restoType, setRestoType] = useState(loggedInResto);
  const [takeoutCustomerDetails, setTakeoutCustomerDetails] = useState({});
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [multiplePrintDone, setMultiplePrintDone] = useState(false);
  const [printSlipsDone, setPrintSlipsDone] = useState(false);
  // const [ipAddress, setIpAddress] = useState("");
  const [openRemarksModal, setOpenRemarksModal] = useState(false);
  const [orderCartIndex, setOrderCartIndex] = useState(null);
  const [tempRemarks, setTempRemarks] = useState("");
  const [disableTableClick, setDisableTableClick] = useState(false);
  const [printingInProgress, setPrintingInProgress] = useState(false);
  const [loading, setLoading] = useState(false);
  
  async function handleTableReservation(status) {
    setAction("reserve");
    if (status === "reserved") {
      recordUserActivityLog(`Reserved table no. ${selectedTable.table_no}`);
    } else {
      recordUserActivityLog(
        `Cancelled reservation for table no. ${selectedTable.table_no}`
      );
    }

    const payload = {
      token: getToken(),
      table_id: selectedTable.id,
      status: status,
    };
    callPost("qrcodes/mark_reserved", payload, false, loggedInResto);
  }

  async function handleTableActivation(passedTable, status, flagged = false, isRefresh = true) {
    recordUserActivityLog(`Set ${passedTable.table_no} status to ${status}`);
    if(status === "attending"){
      localStorage.setItem("is_attending", JSON.stringify(passedTable));
    }
    
    const payload = {
      token: getToken(),
      table_id: passedTable.id,
      status: status,
    };
    const response = await UsePostRequest(
      "qrcodes/mark_reserved",
      payload,
      false,
      loggedInResto
    );
    if (response.data) {
      fetchAllTables();
      if(flagged){
        return true
      }
      if(status === "active" && !localIsAttending){
        if(isRefresh){
          handleRemoveProduct();
          setTimeout(() => {
            refreshPage();
          }, 500);
        }
      }
    } else {
      if(flagged){
        return false
      }
    }
    setDisableTableClick(false);
  }

  const handleShowAddItem = (show) => {
    localStorage.setItem("show_add_item", JSON.stringify(show));
  }

  const handleSelectedTable = (table) => {
    const selected_data = table || {}
    localStorage.setItem("selected_table", JSON.stringify(selected_data));
    if(table){
      setSelectedTable({ ...table, price_type: priceType });
    } else {
      setSelectedTable({});
    }
  }

  const handleRemoveProduct = () => {
    localStorage.removeItem("selected_table");
    localStorage.removeItem("order_show");
    localStorage.removeItem("food_server");
    localStorage.removeItem("product_show");
    localStorage.removeItem("is_attending");
    localStorage.removeItem("order_show");
    localStorage.removeItem("attending_transfer");
    localStorage.removeItem("show_add_item");
    localStorage.removeItem("open_pax_count");
  }

  const handleRemoveActiveAttending = async (isRefresh = false) => {
    if(localIsAttending){
      await handleTableActivation(localIsAttending,"active",)
    }
    if(isRefresh){
      handleRemoveProduct();
      refreshPage();
    }
  }
  
  const handleProductShow = (show = false) => {
    localStorage.setItem("product_show", JSON.stringify(show));
    localStorage.setItem("food_server", JSON.stringify(foodServer));
  };

  const handlShowPaxCount = ({show, type, isOrder = false, isRemove = false}) => {
    setOpenPaxCountModal(show)
    localStorage.setItem("open_pax_count", JSON.stringify(show));
    
    if(!show && !isOrder){
      if(!isRemove){
        handleRemoveProduct();
      }

      if (!localShowAddItem) {
        handleTableActivation(selectedTable, type);
      }
    }
  }

  async function handleHomeButton() {
    let isActivate = false
    if (!localShowAddItem && !localIsAttending) {
      isActivate =  await handleTableActivation(selectedTable, "inactive", true);
    } else {
      isActivate = await handleTableActivation(selectedTable, "active", true);
    }

    if(isActivate){
      refreshPage();
    }
    handleRemoveProduct();
  }

  function convertToInt(input) {
    if (typeof input === "number") {
      return Math.floor(input);
    }
    if (typeof input === "string") {
      const sanitizedString = input.replace(/,/g, "");
      return Math.floor(parseFloat(sanitizedString));
    }
    // return input
  }

  function handleAddToCart(product, productIndex) {
    const itemIndex = orderCart.findIndex(
      (item) => item.id === product.id && item.pricelist === priceType
    );

    if (itemIndex === -1) {
      // If item is not in the orderCart, add
      const newOrder = {
        ...product,
        counter: 1,
        pricelist: priceType,
        product_index: productIndex,
        remarks: "",
      };
      if (localShowAddItem) {
        newOrder.is_additional = true;
      }
      setOrderCart([...orderCart, newOrder]);
    } else {
      // otherwise, increment the counter
      const updatedCart = [...orderCart];
      const tempCounter = convertToInt(updatedCart[itemIndex].counter) + 1;
      updatedCart[itemIndex].counter = tempCounter;
      // updatedCart[itemIndex].counter += 1; //prev method
      updatedCart[itemIndex].pricelist = priceType;
      setOrderCart(updatedCart);
    }

    // WHEN DEALING WITH ADDING ADDITIONAL ITEMS
    if (localShowAddItem) {
      const addItemIndex = additionalItems.findIndex(
        (item) => item.id === product.id && item.pricelist === priceType
      );

      if (addItemIndex === -1) {
        const newItem = { ...product };
        newItem.counter = 1;
        newItem.pricelist = priceType;
        newItem.remarks = "";
        setAdditionalItems([...additionalItems, newItem]);
      } else {
        const updatedAdditions = [...additionalItems];
        const tempCounter =
          convertToInt(updatedAdditions[addItemIndex].counter) + 1;
        updatedAdditions[addItemIndex].counter = tempCounter;
        // updatedAdditions[addItemIndex].counter += 1; //prev method
        updatedAdditions[addItemIndex].pricelist = priceType;
        setAdditionalItems(updatedAdditions);
      }
    }

    if (
      allProducts[selectedCategory] &&
      allProducts[selectedCategory][productIndex]
    ) {
      const updatedProducts = [...allProducts[selectedCategory]];
      updatedProducts[productIndex] = {
        ...updatedProducts[productIndex],
        [`${priceType}_counter`]:
          updatedProducts[productIndex][`${priceType}_counter`] + 1,
      };
      setAllProducts({
        ...allProducts,
        [selectedCategory]: updatedProducts,
      });
    } else {
      toast.error("Selected category or product index does not exist.");
    }

    if (product.menu_location ==="hanamaruken") {
      if (
        allBriqueProducts[selectedCategory] &&
        allBriqueProducts[selectedCategory][productIndex]
      ) {
        const updatedProducts = [...allBriqueProducts[selectedCategory]];
        const tempCounter =
          convertToInt(updatedProducts[productIndex][`${priceType}_counter`]) +
          1;
        updatedProducts[productIndex] = {
          ...updatedProducts[productIndex],
          [`${priceType}_counter`]: tempCounter,
        };

        // updatedProducts[productIndex] = {
        //   ...updatedProducts[productIndex],
        //   [`${priceType}_counter`]:
        //     updatedProducts[productIndex][`${priceType}_counter`] + 1,
        // };
        setAllBriqueProducts({
          ...allBriqueProducts,
          [selectedCategory]: updatedProducts,
        });
      } else {
        toast.error("Selected category or product index does not exist.");
      }
    } else {
      // if (
      //   allEttasProducts[selectedCategory] &&
      //   allEttasProducts[selectedCategory][productIndex]
      // ) {
      //   const updatedProducts = [...allEttasProducts[selectedCategory]];
      //   const tempCounter =
      //     convertToInt(updatedProducts[productIndex][`${priceType}_counter`]) +
      //     1;
      //   updatedProducts[productIndex] = {
      //     ...updatedProducts[productIndex],
      //     [`${priceType}_counter`]: tempCounter,
      //   };

      //   // updatedProducts[productIndex] = {
      //   //   ...updatedProducts[productIndex],
      //   //   [`${priceType}_counter`]:
      //   //     updatedProducts[productIndex][`${priceType}_counter`] + 1,
      //   // };
      //   setAllEttasProducts({
      //     ...allEttasProducts,
      //     [selectedCategory]: updatedProducts,
      //   });
      // } else {
      //   toast.error("Selected category or product index does not exist.");
      // }
    }
  }

  function handleRemoveFromCart(product, productIndex) {
    const itemIndex = orderCart.findIndex(
      (item) => item.id === product.id && item.pricelist === priceType
    );
    if (itemIndex !== -1) {
      const updatedCart = [...orderCart];
      updatedCart[itemIndex].counter -= 1;
      if (updatedCart[itemIndex].counter <= 0) {
        updatedCart.splice(itemIndex, 1);
      }
      setOrderCart(updatedCart);

      const updatedProducts = [...allProducts[selectedCategory]];
      const tempCounter =
        convertToInt(updatedProducts[productIndex][`${priceType}_counter`]) - 1;
      updatedProducts[productIndex] = {
        ...updatedProducts[productIndex],
        [`${priceType}_counter`]: tempCounter,
      };

      // updatedProducts[productIndex] = {
      //   ...updatedProducts[productIndex],
      //   [`${priceType}_counter`]:
      //     updatedProducts[productIndex][`${priceType}_counter`] - 1,
      // };
      setAllProducts({
        ...allProducts,
        [selectedCategory]: updatedProducts,
      });

      if (product.menu_location ==="hanamaruken") {
        const updatedProducts = [...allBriqueProducts[selectedCategory]];
        const tempCounter =
          convertToInt(updatedProducts[productIndex][`${priceType}_counter`]) -
          1;
        updatedProducts[productIndex] = {
          ...updatedProducts[productIndex],
          [`${priceType}_counter`]: tempCounter,
        };

        // updatedProducts[productIndex] = {
        //   ...updatedProducts[productIndex],
        //   [`${priceType}_counter`]:
        //     updatedProducts[productIndex][`${priceType}_counter`] - 1,
        // };
        setAllBriqueProducts({
          ...allBriqueProducts,
          [selectedCategory]: updatedProducts,
        });
      } else {
        // const updatedProducts = [...allEttasProducts[selectedCategory]];
        // updatedProducts[productIndex] = {
        //   ...updatedProducts[productIndex],
        //   [`${priceType}_counter`]:
        //     updatedProducts[productIndex][`${priceType}_counter`] - 1,
        // };
        // setAllEttasProducts({
        //   ...allEttasProducts,
        //   [selectedCategory]: updatedProducts,
        // });
      }
    }

    if (localShowAddItem) {
      const addItemIndex = additionalItems.findIndex(
        (item) => item.id === product.id && item.pricelist === priceType
      );
      if (addItemIndex !== -1) {
        const updatedAdditionalCart = [...additionalItems];
        const tempCounter =
          convertToInt(updatedAdditionalCart[addItemIndex].counter) - 1;

        updatedAdditionalCart[addItemIndex].counter = tempCounter;
        // updatedAdditionalCart[addItemIndex].counter -= 1;
        updatedAdditionalCart[addItemIndex].remarks = "";
        if (updatedAdditionalCart[addItemIndex].counter <= 0) {
          updatedAdditionalCart.splice(addItemIndex, 1);
        }
        setAdditionalItems(updatedAdditionalCart);
      }
    }
  }

  function handleManualQty(product, productIndex, passedValue) {
    const itemIndex = orderCart.findIndex(
      (item) => item.id === product.id && item.pricelist === priceType
    );

    const inputValue = passedValue === "" ? 0 : parseInt(passedValue);

    if (itemIndex === -1) {
      // If item is not in the orderCart, add
      if (inputValue > 0) {
        const newOrder = { ...product };
        newOrder.counter = convertToInt(inputValue);
        newOrder.pricelist = priceType;
        newOrder[`${priceType}_counter`] = convertToInt(inputValue);
        newOrder.product_index = productIndex;
        newOrder.remarks = "";
        if (localShowAddItem) {
          newOrder.is_additional = true;
        }
        setOrderCart([...orderCart, newOrder]);
      }
    } else {
      // otherwise, replace the current qty
      const updatedCart = [...orderCart];
      if (inputValue > 0) {
        updatedCart[itemIndex].counter = convertToInt(inputValue);
        updatedCart[itemIndex].pricelist = priceType;
        updatedCart[itemIndex][`${priceType}_counter`] =
          convertToInt(inputValue);
      } else {
        updatedCart.splice(itemIndex, 1);
      }
      setOrderCart(updatedCart);
    }

    // WHEN DEALING WITH ADDING ADDITIONAL ITEMS
    if (localShowAddItem) {
      const addItemIndex = additionalItems.findIndex(
        (item) => item.id === product.id && item.pricelist === priceType
      );
      if (addItemIndex === -1) {
        if (inputValue > 0) {
          const newItem = { ...product };
          newItem.counter = convertToInt(inputValue);
          newItem.pricelist = priceType;
          newItem.remarks = "";
          setAdditionalItems([...additionalItems, newItem]);
        }
      } else {
        const updatedAdditions = [...additionalItems];
        if (inputValue > 0) {
          updatedAdditions[addItemIndex].counter = convertToInt(inputValue);
          updatedAdditions[addItemIndex].pricelist = priceType;
        } else {
          updatedAdditions.splice(addItemIndex, 1);
        }
        setAdditionalItems(updatedAdditions);
      }
    }

    if (
      allProducts[selectedCategory] &&
      allProducts[selectedCategory][productIndex]
    ) {
      const updatedProducts = [...allProducts[selectedCategory]];
      updatedProducts[productIndex] = {
        ...updatedProducts[productIndex],
        [`${priceType}_counter`]: convertToInt(inputValue),
      };
      setAllProducts({
        ...allProducts,
        [selectedCategory]: updatedProducts,
      });
    } else {
      toast.error("Selected category or product index does not exist.");
    }

    if (product.menu_location ==="hanamaruken") {
      if (
        allBriqueProducts[selectedCategory] &&
        allBriqueProducts[selectedCategory][productIndex]
      ) {
        const updatedProducts = [...allBriqueProducts[selectedCategory]];
        updatedProducts[productIndex] = {
          ...updatedProducts[productIndex],
          [`${priceType}_counter`]: convertToInt(inputValue),
        };
        setAllBriqueProducts({
          ...allBriqueProducts,
          [selectedCategory]: updatedProducts,
        });
      } else {
        toast.error("Selected category or product index does not exist.");
      }
    } else {
      // if (
      //   allEttasProducts[selectedCategory] &&
      //   allEttasProducts[selectedCategory][productIndex]
      // ) {
      //   const updatedProducts = [...allEttasProducts[selectedCategory]];
      //   updatedProducts[productIndex] = {
      //     ...updatedProducts[productIndex],
      //     [`${priceType}_counter`]: convertToInt(inputValue),
      //   };
      //   setAllEttasProducts({
      //     ...allEttasProducts,
      //     [selectedCategory]: updatedProducts,
      //   });
      // } else {
      //   toast.error("Selected category or product index does not exist.");
      // }
    }
  }

  function handleModifierOrder(type, e, menu_modifier) {
    if(type === "addons"){
      const {value, checked } = e.target

      setModifierOrder((prevState) => {
        let updatedItems = prevState.modifier;

        if (checked) {
          updatedItems = [...updatedItems, menu_modifier];
        } else {
          // Remove item if unchecked
          updatedItems = updatedItems?.filter((item) => item.id !== value);
        }

        return { ...prevState, modifier: updatedItems };
      });
    } else if(type === "add") {
      setModifierOrder((prev) => ({
        ...prev,
        counter: parseInt(prev.counter || 0) + 1,
      }));
    } else if(type === "minus") {
      if(modifierOrder?.counter > 0){
        setModifierOrder((prev) => ({
          ...prev,
          counter: parseInt(prev.counter || 0) - 1,
        }));
      }
    } else if(type === "input"){
      setModifierOrder((prev) => ({
        ...prev,
        counter: e.target.value,
      }));
    }
  }

  function handleAddModifierOrder() {
    let order = {};

    const areArraysEqual = (arr1, arr2) => {
      if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false; // Check if both are arrays
      if (arr1.length !== arr2.length) return false; // Check if lengths are equal
      return arr1.every((item) => arr2.includes(item)); // Compare contents
    };
  

    if (modifierOrder && modifierOrder.modifier) {
      let totalAmount = modifierOrder.modifier.reduce((sum, item) => {
        const amount = parseFloat(item.price);
        return sum + (isNaN(amount) ? 0 : amount);
      }, 0);

      let totalModifierId = modifierOrder.modifier.reduce((sum, item) => {
        const amount = parseInt(item.modifier_id);
        return sum + (isNaN(amount) ? 0 : amount);
      }, 0);
  
      const count = modifierOrder.counter || 0;
      const mod = modifierOrder.modifier || [];
      const total_order = (parseFloat(modifierData.price) + parseFloat(totalAmount)) || 0;
  
      order = {
        ...modifierData,
        counter: count,
        addons: mod,
        pricelist: priceType,
        is_additional: localShowAddItem ? true : false,
        with_modifier_total: `${total_order.toFixed(2)}`,
        [priceType + "_price"]: `${total_order.toFixed(2)}`,
        with_modifier_id: `${parseInt(totalModifierId) + parseInt(modifierData.id)}`,
      };

      setOrderCart((prevState) => {
        const orderExistsIndex = prevState.findIndex(
          (existingOrder) => (existingOrder.id === order.id) && areArraysEqual(existingOrder?.addons, order?.addons)
        );

        if (orderExistsIndex === -1) {
          return [...prevState, order];
        } else {
          const updatedOrderCart = [...prevState];
          const existingOrder = updatedOrderCart[orderExistsIndex];
      
          const updatedCounter = existingOrder.counter + order.counter;
          const updatedTotal = (parseFloat(modifierData.price) + parseFloat(totalAmount)) || 0;
      
          updatedOrderCart[orderExistsIndex] = {
            ...existingOrder,
            counter: updatedCounter,
            with_modifier_total: `${updatedTotal.toFixed(2)}`,
          };
      
          return updatedOrderCart;
        }
      });
      setModifierOrder((prev) => ({
        ...prev,
        counter: 0
      }))
      setOpenModifier(false)
    }

    if (localShowAddItem) {
      
      const addItemIndex = additionalItems.findIndex(
        (item) => item.id === modifierOrder.id && item.pricelist === priceType
      );

      if (addItemIndex === -1) {
        setAdditionalItems([...additionalItems, order]);
      } else {
        setAdditionalItems((prevState) => {
          const updatedOrderCart = [...prevState];
          const existingOrder = updatedOrderCart[addItemIndex];
      
          const updatedCounter = existingOrder.counter + order.counter;
          const updatedTotal = (parseFloat(modifierData.price) + parseFloat(totalAmount)) || 0;
      
          updatedOrderCart[addItemIndex] = {
            ...existingOrder,
            counter: updatedCounter,
            with_modifier_total: `${updatedTotal.toFixed(2)}`,
          };
      
          return updatedOrderCart;
        });
      }
    }
  }

  function handleDeleteFromCart(item) {
    if(item?.with_modifier === "1"){
      const updatedArray = orderCart.filter(obj => obj.with_modifier_id !== item.with_modifier_id);
      setOrderCart(updatedArray)
    } else {
      const productIndex = item.product_index;
      const itemPriceType = item.pricelist;

      const newCart = orderCart.filter(
        (cart) => cart.id !== item.id || cart.pricelist !== item.pricelist
      );
      setOrderCart(newCart);

      // Update the product option counter as well
      if (item.menu_location === restoType) {
        const updatedProducts = [...allProducts[item.category]];
        const tempCounter =
          convertToInt(
            updatedProducts[productIndex][`${itemPriceType}_counter`]
          ) - convertToInt(item.counter);
        updatedProducts[productIndex] = {
          ...updatedProducts[productIndex],
          [`${itemPriceType}_counter`]: tempCounter,
        };

        // updatedProducts[productIndex] = {
        //   ...updatedProducts[productIndex],
        //   [`${itemPriceType}_counter`]:
        //     updatedProducts[productIndex][`${itemPriceType}_counter`] -
        //     item.counter,
        // };
        setAllProducts({
          ...allProducts,
          [item.category]: updatedProducts,
        });
      } 

      if (item.menu_location ==="hanamaruken") {
        const updatedProducts = [...allBriqueProducts[item.category]];
        const tempCounter =
          convertToInt(
            updatedProducts[productIndex][`${itemPriceType}_counter`]
          ) - convertToInt(item.counter);
        updatedProducts[productIndex] = {
          ...updatedProducts[productIndex],
          [`${itemPriceType}_counter`]: tempCounter,
        };

        // updatedProducts[productIndex] = {
        //   ...updatedProducts[productIndex],
        //   [`${itemPriceType}_counter`]:
        //     updatedProducts[productIndex][`${itemPriceType}_counter`] -
        //     item.counter,
        // };
        setAllBriqueProducts({
          ...allBriqueProducts,
          [item.category]: updatedProducts,
        });
      } else {
        // const updatedProducts = [...allEttasProducts[item.category]];
        // const tempCounter =
        //   convertToInt(
        //     updatedProducts[productIndex][`${itemPriceType}_counter`]
        //   ) - convertToInt(item.counter);
        // updatedProducts[productIndex] = {
        //   ...updatedProducts[productIndex],
        //   [`${itemPriceType}_counter`]: tempCounter,
        // };

        // // updatedProducts[productIndex] = {
        // //   ...updatedProducts[productIndex],
        // //   [`${itemPriceType}_counter`]:
        // //     updatedProducts[productIndex][`${itemPriceType}_counter`] -
        // //     item.counter,
        // // };
        // setAllEttasProducts({
        //   ...allEttasProducts,
        //   [item.category]: updatedProducts,
        // });
      }
    }
  }

  async function handleVoidOrder(passedValues) {
    setAction("void");

    // NEW APPROACH PARA NAAY PRINT SA DISPATCH ANG ORIGINAL AND VOIDED -_-
    // const tempParentArray = [];
    const childArray = [];
    orderItems.forEach((item) => {
      if (itemsToVoid.includes(item.id)) {
        // var parentInfo = {
        //   ...item,
        //   menu_id: item.menu_id,
        //   counter: parseFloat(item.qty) - parseFloat(item.counter),
        //   qty: parseFloat(item.qty) - parseFloat(item.counter),
        // };
        // tempParentArray.push(parentInfo);
        var childInfo = {
          ...item,
          menu_id: item.menu_id,
          counter: parseFloat(item.counter),
        };
        childArray.push(childInfo);
      } else {
        // var info = {
        //   ...item,
        //   menu_id: item.menu_id,
        //   counter: item.qty,
        // };
        // tempParentArray.push(info);
      }
    });

    // const parentArray = tempParentArray.filter((item) => item.counter !== 0);
    // filter out items that are removed from the order
    const removedItemIds = childArray.map((item) => item.id);
    const removedItems = [];
    var childArrayIndex = 0;
    orderItems.forEach((item, index) => {
      if (
        removedItemIds.includes(item.id) &&
        childArray[childArrayIndex]
      ) {
        var newItem = {
          ...item,
          qty: childArray[childArrayIndex].counter,
        };
        removedItems.push(newItem);
        childArrayIndex += 1;
      }
    });
    // setDispatchItems(parentArray);
    // setVoidedItems(removedItems);
    removedItems.forEach((item) => {
      recordUserActivityLog(
        `Voided ${item.qty} ${item.name} from table no. ${selectedTable.table_no}`
      );
    });

    // NEW APPROACH PARA NAAY PRINT SA DISPATCH ANG ORIGINAL AND VOIDED -_-
    const payload = {
      reason: userRole === "1" || userRole === "7" ? "" : passedValues.reason,
      authorized_by:
        userRole === "1" || userRole === "7" ? getUser() : passedValues.id,
      password:
        userRole === "1" || userRole === "7"
          ? ""
          : passedValues.password_string,
      order_detail_ids: removedItems.map((item) => item.id),
      voided_qty: removedItems.map((item) => item.counter),
    };
    callPut("order_details/mark_void", payload, loggedInResto);
  }

  async function handleReprintOrder() {
    setAction("reprint");

    const childArray = [];
    orderItems.forEach((item) => {
      if (itemsToVoid.includes(item.id)) {
        var childInfo = {
          ...item,
          menu_id: item.menu_id,
          counter: parseFloat(item.counter),
        };
        childArray.push(childInfo);
      } else {
        
      }
    });

    const removedItemIds = childArray.map((item) => item.id);
    const removedItems = [];
    var childArrayIndex = 0;
    orderItems.forEach((item, index) => {
      if (
        removedItemIds.includes(item.id) &&
        childArray[childArrayIndex]
      ) {
        var newItem = {
          ...item,
          qty: childArray[childArrayIndex].counter,
        };
        removedItems.push(newItem);
        childArrayIndex += 1;
      }
    });

    removedItems.forEach((item) => {
      recordUserActivityLog(
        `Reprint ${item.qty} ${item.name} from table no. ${selectedTable.table_no}`
      );
    });

    let result = {};
    let bar = {};

    if (removedItems) {
      removedItems.forEach((data) => {
        const printer = data.default_printer;

        if (printer === "BAR") {
          if (!bar.BAR) {
            bar.BAR = [];
          }
          bar.BAR.push(data);
        } else {
          const orderId = data.id;

          const qty = Number(data.qty) || 1; // Ensure qty is a number and default to 1 if undefined

          for (let i = 0; i < qty; i++) {
            const uniqueKey = `${printer}_${orderId}_${i}`;

            if (!result[uniqueKey]) {
              result[uniqueKey] = [];
            }

            result[uniqueKey].push({ ...data, qty: 1 }); // Push a copy of the data for each qty
          }
        }
      });
    }

    let reprint_slip = { ...result, ...bar };

    setOrderSlips(reprint_slip);

  }

  const confirmCancel = () => {
    modal.confirm({
      title: `ARE YOU SURE YOU WANT TO CANCEL THIS ORDER?`,
      icon: <ExclamationCircleOutlined className="warning-icon" />,
      content: (
        <>
          <Row className="modal-text">You cannot undo this action.</Row>
          <Row>
            <Input
              className="bigger-input-field"
              placeholder="Enter reason for cancelling"
              onChange={(e) => setReason(e.target.value)}
            />
          </Row>
        </>
      ),
      okText: "CONFIRM",
      cancelText: "CANCEL",
      onOk: () => handleCancelOrder(),
      okType: "danger",
      width: 600,
    });
  };

  const confirmCancelAttending = (passedTable) => {
    modal.confirm({
      title: `ARE YOU SURE YOU WANT TO CANCEL ATTENDING?`,
      icon: <ExclamationCircleOutlined className="warning-icon" />,
      okText: "CONFIRM",
      cancelText: "CANCEL",
      onOk: () => {
        handleTableActivation(passedTable, "inactive");
      },
      okType: "",
      width: 600,
    });
  };

  async function handleCancelOrder(passedValues) {
    setAction("cancel");
    const payload = {
      reason:
        userRole === "1" || userRole === "7" ? reason : passedValues.reason,
      authorized_by:
        userRole === "1" || userRole === "7" ? getUser() : passedValues.id,
      authorized_token:
        userRole === "1" || userRole === "7" ? getToken() : passedValues.token,
    };
    callPut("orders/mark_cancel/" + selectedOrder.id, payload, loggedInResto);
  }

  const confirmMerge = () => {
    modal.confirm({
      title: `ARE YOU SURE YOU WANT TO MERGE THESE TABLES?`,
      icon: <ExclamationCircleOutlined className="warning-icon" />,
      content: (
        <>
          <Row>
            {[selectedTable, ...tablesToMerge].map((table, index) => (
              <Col key={index} lg={6} xs={8} className="">
                <Card className="p-0 text-center store-clicked">
                  {table.table_no}
                </Card>
              </Col>
            ))}
          </Row>
          <Row className="modal-text mt-2">You cannot undo this action.</Row>
        </>
      ),
      okText: "CONFIRM",
      cancelText: "CANCEL",
      onOk: () => handleMergeOrder(),
      okType: "",
      width: 600,
    });
  };

  async function handleMergeOrder() {
    setAction("merge");
    const payload = {
      token: getToken(),
      parent_table: selectedTable.id,
      table_nos: tableIdToMerge,
    };
    recordUserActivityLog(
      `Merged table ${selectedTable.table_no} with table IDs ${tableIdToMerge}`
    );
    callPost("qrcodes/mergeTable", payload, false, loggedInResto);
  }

  async function handleSplitOrder() {
    setAction("split");
    const tempParentArray = [];
    const childArray = [];
    orderItems.forEach((item) => {
      if (itemsToVoid.includes(item.id)) {
        var parentInfo = {
          menu_id: item.menu_id,
          counter: parseFloat(item.qty) - parseFloat(item.counter),
        };
        tempParentArray.push(parentInfo);
        var childInfo = {
          menu_id: item.menu_id,
          counter: parseFloat(item.counter),
        };
        childArray.push(childInfo);
      } else {
        var info = {
          menu_id: item.menu_id,
          counter: item.qty,
        };
        tempParentArray.push(info);
      }
    });

    const parentArray = tempParentArray.filter((item) => item.counter !== 0);
    // filter out items that are removed from the order
    const removedItemIds = childArray.map((item) => item.menu_id);

    const removedItems = [];
    var childArrayIndex = 0;
    orderItems.forEach((item, index) => {
      if (removedItemIds.includes(item.menu_id)) {
        var newItem = {
          ...item,
          qty: childArray[childArrayIndex]?.counter,
        };
        removedItems.push(newItem);
        childArrayIndex += 1;
      }
    });
    setVoidedItems(removedItems); // split ni
    removedItems.forEach((item) => {
      recordUserActivityLog(
        `Split ${item.qty} ${item.name} from table no. ${selectedTable.table_no}`
      );
    });

    const childTables = [
      `${selectedTable.table_no}A`,
      `${selectedTable.table_no}B`,
    ];
    const payload = {
      table_to_split: selectedTable.id,
      child_tables: childTables,
    };
    childTables.forEach((child, index) => {
      if (index === 0) {
        payload["menu_" + child] = parentArray.map((item) => item.menu_id);
        payload["qty_" + child] = parentArray.map((item) => item.counter);
        payload["pax_" + child] =
          parseInt(selectedOrder.pax) - parseInt(paxCount);
        payload["remark_" + child] = [];
      } else {
        payload["menu_" + child] = childArray.map((item) => item.menu_id);
        payload["qty_" + child] = childArray.map((item) => item.counter);
        payload["pax_" + child] = parseInt(paxCount);
        payload["remark_" + child] = [];
      }
    });
    callPost("orders/createSplit", payload, false, loggedInResto);
  }

  async function handleTransferTable() {
    setAction("transfer");
    const payload = {
      token: getToken(),
      from_table: selectedTable.id,
      to_table: recipientTable.table_id,
    };
    recordUserActivityLog(
      `Transferred table ${selectedTable.table_no} to table ID ${recipientTable.id}`
    );
    callPost(
      "orders/transferTable/" + selectedOrder.id,
      payload,
      false,
      loggedInResto
    );
  }

  async function handleTransferItems() {
    setAction("transfer-items");
    const childArray = [];
    orderItems.forEach((item) => {
      if (itemsToVoid.includes(item.id)) {
        var childInfo = {
          ...item,
          menu_id: item.menu_id,
          counter: parseFloat(item.counter),
        };
        childArray.push(childInfo);
      }
    });

    // filter out items that are removed from the order
    const removedItemIds = childArray.map((item) => item.menu_id);
    const removedItems = [];
    var childArrayIndex = 0;
    orderItems.forEach((item, index) => {
      if (
        removedItemIds.includes(item.menu_id) &&
        childArray[childArrayIndex]
      ) {
        var newItem = {
          ...item,
          qty: childArray[childArrayIndex].counter,
        };
        removedItems.push(newItem);
        childArrayIndex += 1;
      }
    });

    recordUserActivityLog(
      `Transferred items ${selectedTable.table_no} to table ID ${recipientTable.id}`
    );
    const payload = {
      // updated_by: getUser(),
      // token: getToken(),
      order_detail_ids: removedItems.map((item) => item.id),
      qty: removedItems.map((item) => item.qty),
      qr_id: recipientTable.table_id,
    };

    // callPut("order_details/transfer_item", payload, false, loggedInResto);
    callPost("order_details/transfer_item", payload, false, loggedInResto);
  }
  
  async function handleSubmitOrder() {
    setAction("order");
    setIsSaving(true);
    // handleSocketProgress(true);

    const values = {
      phone_no: "",
      token: selectedTable.token,
      qr_id: selectedTable.id,
      order_no: selectedTable.order_no,
      pax: paxCount,
      table_no: selectedTable.table_no,
      price_type: selectedTable.price_type,
      pricelist: orderCart.map((item) => item.pricelist),
      menu_ids: orderCart.map((item) => item.id),
      added_modifiers: orderCart.map((item) => ({
        [item.id]: item.addons || []
      })),
      qty: orderCart.map((item) => item.counter),
      price: orderCart.map((item) =>
        item.with_modifier === "1" ?
        item.with_modifier_total : 
        item.pricelist === "store"
          ? item.price
          : item[`${item.pricelist}_price`]
      ),
      remarks: orderCart.map((item) => item.remarks),
      remark_2: [],
      food_server: foodServer,
    };

    const response = await UsePostRequest(
      "orders/create",
      values,
      false,
      loggedInResto
    );
    if (response.data) {
      recordUserActivityLog(
        `Added new order on table no. ${selectedTable.table_no}`
      );

      toast.success("Successfully created order");
      const orderDeets = response.data.message;
      const tempOrderId = orderDeets.order_id;
      const tempDispatchItems = orderDeets?.dispatch_slips[tempOrderId] || [];
      setDispatchCounter(orderDeets.dispatch_counter);
      setDispatchItems(tempDispatchItems);
      if (tempDispatchItems && tempDispatchItems.length > 0) {
        setTimeout(() => {
          const printingData = [{ ref: dispatchRef, printer: "DISPATCH" }];
          // const printingData = [{ ref: dispatchRef, printer: "CASHIER" }];
          handleMultiplePrint(printingData);
        }, 1000);
      } else {
        setMultiplePrintDone(true);
      }

      let result = {};
      let bar = {};
      // if(orderDeets.order_slips.others){
      //   orderDeets.order_slips.others.forEach((data, key) => {
      //     const printer = data.default_printer;
  
      //     if (!result[printer + '_' + data.order.id]) {
      //       result[printer + '_' + data.order.id] = [];
      //     }
  
      //     result[printer + '_' + data.order.id] = [data.order];
      //   });
      // }
      if (orderDeets.order_slips.others) {
        orderDeets.order_slips.others.forEach((data, index) => {
          const printer = data.default_printer;
          const orderId = data.order.id;
      
          const uniqueKey = `${printer}_${orderId}_${index}`; // Unique key includes date
      
          if (!result[uniqueKey]) {
            result[uniqueKey] = [];
          }
      
          result[uniqueKey] = [data.order];
        });
      }
      

      if (orderDeets.order_slips["BAR"].length !== 0) {
        bar["BAR"] = orderDeets.order_slips["BAR"];
      }    
      
      // setOrderSlips(orderDeets.order_slips);
      setOrderSlips({...result, ...bar});
    } else {
      toast.error("Error in adding new order");
      setTimeout(() => {
        refreshPage();
      }, 500);
    }
  }

  async function handleAdditionalItems() {
    setAction("add-item");
    setIsSaving(true);
    const values = {
      phone_no: "",
      token: selectedTable.token,
      qr_id: selectedOrder.qr_id,
      // pax: selectedOrder.pax,
      pax: paxCount,
      table_no: selectedTable.table_no,
      menu_ids: additionalItems.map((item) => item.id),
      added_modifiers: additionalItems.map((item) => ({
        [item.id]: item.addons || []
      })),
      qty: additionalItems.map((item) => item.counter),
      pricelist: additionalItems.map((item) => item.pricelist),
      // price: additionalItems.map((item) => item[`${item.pricelist}_price`]),

      price: additionalItems.map((item) =>
        item.with_modifier === "1" ?
        item.with_modifier_total : 
        item.pricelist === "store"
          ? item.price
          : item[`${item.pricelist}_price`]
      ),      
      remarks: additionalItems.map((item) => item.remarks),
    };

    const response = await UsePostRequest(
      "orders/additional/" + selectedOrder.id,
      values,
      false,
      loggedInResto
    );

    if (response.data) {
      additionalItems.forEach((item) => {
        recordUserActivityLog(
          `Added ${item.counter} ${item.name} to table no. ${selectedTable.table_no}`
        );
      });
      toast.success("Successfully added items");
      const orderDeets = response.data.message;
      // setDispatchItems(orderItems);
      const tempOrderId = orderDeets.order_id;
      const tempDispatchItems = orderDeets?.dispatch_slips[tempOrderId] || [];
      setDispatchItems(tempDispatchItems);
      setDispatchCounter(orderDeets.dispatch_counter);

      const tempAddedItems = [];
      Object.keys(orderDeets.order_slips).forEach((key, index) => {
        // if (key?.toLowerCase() !== "bar") {
          orderDeets.order_slips[key].forEach((item) => {
            var info = {
              ...item,
              counter: item.qty,
              name: item.menu_name,
            };
            tempAddedItems.push(info);
          });
        // }
      });

      setNoBarAdditionalItems(tempAddedItems);
      if (
        tempDispatchItems &&
        tempDispatchItems.length > 0 &&
        tempAddedItems.length > 0
      ) {
        setTimeout(() => {
          const printingData = [{ ref: dispatchRef, printer: "DISPATCH" }];
          // const printingData = [{ ref: dispatchRef, printer: "CASHIER" }];
          handleMultiplePrint(printingData);
        }, 1000);
      } else {
        setMultiplePrintDone(true);
      }

      let result = {};
      let bar = {};

      if (orderDeets.order_slips.others) {
        orderDeets.order_slips.others.forEach((data, index) => {
          const printer = data.default_printer;
          const orderId = data.order.id;
      
          const uniqueKey = `${printer}_${orderId}_${index}`; // Unique key includes date
      
          if (!result[uniqueKey]) {
            result[uniqueKey] = [];
          }
      
          result[uniqueKey] = [data.order];
        });
      }
      
      if (orderDeets.order_slips["BAR"].length !== 0) {
        bar["BAR"] = orderDeets.order_slips["BAR"];
      }    
      
      // setOrderSlips(orderDeets.order_slips);
      setOrderSlips({...result, ...bar});
    } else {
      toast.error("Error in adding new order");
      setTimeout(() => {
        refreshPage();
      }, 500);
    }
  }

  async function fetchOrderDiscounts(orderId) {
    const response = await UseGetRequest(
      "order_discounts/show/" + orderId,
      {},
      restoType
    );
    if (response.data) {
      if (
        response.data.order_discount_detail &&
        response.data.order_discount_detail.length > 0
      ) {
        setSelectedOrder({ ...selectedOrder, has_discounts: true });
      } else {
        setSelectedOrder({ ...selectedOrder, has_discounts: false });
      }
    }
  }

  async function fetchOrderInfo(orderId) {
    // setOrderId(orderId);
    const response = await UseGetRequest(
      "orders/show/" + orderId,
      { for_printing: "0" },
      loggedInResto
    );
    if (response.data) {
      localStorage.setItem("order_show", JSON.stringify(response.data.message));
      setSelectedOrder(response.data.message.order);
      setPaxCount(response.data.message.order.pax);
      setFoodServer(response.data.message.order.food_server);
      const tempOrders = response.data.message?.order_details
        ? response.data.message?.order_details.map((item) => {
            return {
              id: item.id,
              menu_id: item.menu_id,
              name: item.menu_name,
              menu_name: item.menu_name,
              counter: item.qty,
              price: item.price,
              [item.pricelist + "_price"]: item.price,
              max_qty: item.qty,
              qty: item.qty,
              pricelist: item.pricelist,
              total: parseFloat(item.price) * parseInt(item.qty),
              remarks: item.remarks,
              addons: item.addons,
              menu_modifier: item.addons,
              menu_details: item.menu_details,
              with_modifier: item.with_modifier,
              with_modifier_total: item.price,
              default_printer: item.default_printer,
            };
          })
        : [];
      setOrderCart(tempOrders);
      setOrderItems(tempOrders);
      setDispatchItems(tempOrders)
      // }
    } else {
      setOrderCart([]);
      setOrderItems([]);
      setSelectedOrder({});
    }
  }

  async function fetchOrderByTable(table) {
    const response = await UseGetRequest(
      "qrcodes/show/" + table.id,
      {
        table_no: table.table_no,
      },
      loggedInResto
    );
    if (response.data) {
      if (response.data.status === 200) {
        fetchOrderInfo(response.data.data.order_id);
        fetchOrderDiscounts(response.data.data.order_id);
      } else {
        toast.error("Table not found");
      }
    } else {
      setSelectedOrder({});
    }

    setDisableTableClick(false);
  }

  // const handleReprintDispatch = () => {
  //   const printingData = [{ ref: dispatchRef, printer: "DISPATCH" }];
  //   // const printingData = [{ ref: dispatchRef, printer: "CASHIER" }];
  //   setTimeout(() => {
  //     handleMultiplePrint(printingData, "reprint");
  //   }, 1000);
  // }
  const handleMultiplePrint = async (passedData, reprint) => {
    setPrintingInProgress(true);
    return new Promise((resolve, reject) => {
      const promises = passedData.map((item) => {
        return new Promise((innerResolve, innerReject) => {
          if (item.ref.current) {
            const element = item.ref.current;
            html2canvas(element, { scale: 1 })
              .then((canvas) => {
                const imgData = canvas.toDataURL("image/png");
                if(reprint){
                  handleReprintApi(
                    imgData, 
                    item.printer, 
                    () => {innerResolve();},
                  );
                } else {
                  handlePrintApi(imgData, item.printer, () => {
                    innerResolve();
                  });
                }
              })
              .catch((error) => {
                innerReject(error);
              });
          } else {
            innerResolve();
          }
        });
      });

      Promise.all(promises)
        .then(() => {
          resolve();
          setMultiplePrintDone(true);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  async function fetchAllTables() {
    // INITIALIZE TABLES BUT REMEMBER, THEY WON'T APPEAR ON SCREEN UNLESS THEY WERE ADDED IN THE DATABASE qrcode TBALE
    const tableReference = {
      store: [],
      takeout: [],
      delivery: [],
      foodpanda: [],
      grab: [],
    };
    for (let index = 0; index < 20; index++) {
      let indexStr = index.toString();
      tableReference.store.push("-");
      tableReference.takeout.push("T-" + indexStr);
      tableReference.delivery.push("D-" + indexStr);
      tableReference.foodpanda.push("F-" + indexStr);
      tableReference.grab.push("G-" + indexStr);
    }

    const response = await UseGetRequest(
      "orders/getAllTable",
      {},
      loggedInResto
    );
    if (response.data) {
      const responseTables = response.data.message.data;
      const temp = {
        store: responseTables
          .filter(
            (tab) =>
              tab.table_no.charAt(2) !== "D" &&
              tab.table_no.charAt(2) !== "F" &&
              tab.table_no.charAt(2) !== "G" &&
              tab.table_no.charAt(0) !== "T" 
          )
          .sort((a, b) => a.table_no - b.table_no),
        takeout: responseTables
           .filter(
            (tab) =>
              tab.table_no.charAt(0) === "T"
          )
          .sort((a, b) => a.table_no - b.table_no),
        delivery: responseTables
          .filter((tab) => {
            return tableReference.delivery.some((storeItem) =>
              tab.table_no.startsWith(storeItem)
            );
          })
          .sort((a, b) => a.table_no - b.table_no),
        foodpanda: responseTables
          .filter((tab) => {
            return tableReference.foodpanda.some((storeItem) =>
              tab.table_no.startsWith(storeItem)
            );
          })
          .sort((a, b) => a.table_no - b.table_no),
        grab: responseTables
          .filter((tab) => {
            return tableReference.grab.some((storeItem) =>
              tab.table_no.startsWith(storeItem)
            );
          })
          .sort((a, b) => a.table_no - b.table_no),
      };
      setAllTables(temp);
      var tempMerge = [];
      responseTables.forEach((tab) => {
        if (tab.merge_to) {
          tempMerge.push(tab.id, tab.merge_to);
        }
      });
      setMergedTables(tempMerge);
    } else {
      setMergedTables([]);
      setAllTables(tableReference);
    }
  }

  // FETCH ALL BRIQUE PRODUCTS PER CATEGORY
  async function fetchAllBriqueProducts() {
    setBriqueCategories([]);
    setAllBriqueProducts({});
    const tempProducts = {};
    const tempCategories = [];
    const menusResponse = await UseGetRequest(
      "menus/getAll",
      { menu_location:"hanamaruken" },
      loggedInResto
    );
    if (menusResponse.data) {
      menusResponse.data.menus.forEach((cat) => {
        cat.products = cat.products.map((item) => {
          const updatedItem = {
            ...item,
            store_price: item.price,
            delivery_price: item.price,
            counter: 0,
            menu_location:"hanamaruken",
            category: cat.category_name,
          };
          priceTypes.forEach((type) => {
            updatedItem[`${type}_counter`] = 0;
          });
          return updatedItem;
        });
        tempCategories.push({ id: cat.category_id, name: cat.category_name });
        tempProducts[cat.category_name] = cat.products;
      });
      // setSelectedCategory(tempCategories[0].name);
      setBriqueCategories(tempCategories);
      setAllBriqueProducts(tempProducts);

      if (restoType ==="hanamaruken") {
        setAllProducts(tempProducts);
        setAllCategories(tempCategories);
        setSelectedCategory(tempCategories[0].name);
      }
    }
  }

  // Fetch All Ettas Products
  // async function fetchAllEttasProducts() {
  //   setEttasCategories([]);
  //   setAllEttasProducts({});
  //   const tempProducts = {};
  //   const tempCategories = [];
  //   const menusResponse = await UseGetRequest(
  //     "menus/getAll",
  //     { menu_location: "ettas" },
  //     loggedInResto
  //   );
  //   if (menusResponse.data) {
  //     menusResponse.data.menus.forEach((cat) => {
  //       cat.products = cat.products.map((item) => {
  //         const updatedItem = {
  //           ...item,
  //           store_price: item.price,
  //           delivery_price: item.price,
  //           counter: 0,
  //           menu_location: "ettas",
  //           category: cat.category_name,
  //         };
  //         priceTypes.forEach((type) => {
  //           updatedItem[`${type}_counter`] = 0;
  //         });
  //         return updatedItem;
  //       });
  //       tempCategories.push({ id: cat.category_id, name: cat.category_name });
  //       tempProducts[cat.category_name] = cat.products;
  //     });
  //     setEttasCategories(tempCategories);
  //     setAllEttasProducts(tempProducts);

  //     if (restoType === "ettas") {
  //       setAllProducts(tempProducts);
  //       setAllCategories(tempCategories);
  //       setSelectedCategory(tempCategories[0].name);
  //     }
  //   }
  // }

  async function handlePrintApi(image, printerName, callback) {
    const response = await printBase64(printerName, image, "0", loggedInResto);
    // if (printerName?.toLowerCase() === "dispatch") {
    //   const secondPrinting = await printBase64(
    //     printerName,
    //     image,
    //     "0",
    //     loggedInResto
    //   );
    // }
  
    setTimeout(() => {
      callback();
      handleRemoveProduct();
    }, 1000);
  }

  async function handleReprintApi(image, printerName, callback) {
    try {
      const response = await printBase64(printerName, image, "0", loggedInResto);
    } catch (error) {
      toast.error('Error dispatch reprint!');
    } finally {
      setPrintingInProgress(false);  
      setTimeout(() => {
        callback();
        handleRemoveProduct();
      }, 1000);
    }
  }
  

  async function handleOpenCashDrawer() {
    const response = await printOpenCashDrawer(window.printer_name);
    if (response.data) {
    } else {
    }
  }

  async function handleDisableAttending() {
    setLoading(true);
    try {
      const response = await UseGetRequest(
        "qrcodes/disable_attending/",
        {},
        ""
      );

      if (response?.data) {
        console.log("Success");
      } else {
        console.log("No data returned");
      }
    } catch (error) {
      console.error("Error disabling attending:", error);
    } finally {
      fetchAllTables();
      setTimeout(() => {
        setLoading(false);
      }, 5000); // 2000ms = 2 seconds
    }
  }

  async function printMultipleOrderSlips(passedOrderSlips, isBreak, type) {
    setPrintingInProgress(true);
    if(type === "order slips" || type === "void slips"){
      handleTableActivation(selectedTable,"active", false, false)
    }
    const printerArray = Object.keys(passedOrderSlips);
  
    try {
      await Promise.all(
        printerArray.map(async (printerName, index) => {
          if (!bulkPrintRefs.current[index]) return; // Skip if no element
  
          const element = bulkPrintRefs.current[index];
          const printer_name = isBreak ? printerName.replace(/_.*/, '') : printerName;
  
          try {
            const canvas = await html2canvas(element, { scale: 1 });
            const imgData = canvas.toDataURL("image/png");
  
            await new Promise((resolve, reject) =>
              setTimeout(() => {
                printOrderSlip(index, printer_name, imgData, resolve, reject);
              }, 2000)
            );
          } catch (error) {
            console.log(`Error processing ${printerName}:`, error);
          }
        })
      );
  
      // setPrintSlipsDone(true);
      setTimeout(() => {
        setPrintingInProgress(false);
        if(type === "void slips"){
          refreshPage();
          handleRemoveProduct();
        } else {
          handleHomeButton();
        }
      }, 2000);
    } catch (error) {
      console.log("Printing failed:", error);
    }
  }

  const printOrderSlip = async (index,printerName, image, callback, reject) => {
    const response = await printBase64Bulk( 
      printerName, 
      image, 
      "0",
      selectedTable.table_no,
      index,
    );
    if(response.data){
      callback();
    } else {
      reject();
    }
  };

  const handleBulkPrintRef = (ref) => {
    bulkPrintRefs.current.push(ref);
  };

  function validateContactNumber(contactNumber) {
    // Check if the input is exactly 11 digits and consists only of numbers
    if (contactNumber && contactNumber !== "") {
      const regex = /^\d{11}$/;
      return regex.test(contactNumber);
    } else {
      return false;
    }
  }

  async function handleTableClick(table) {
    setDisableTableClick(true);
    setOrderCart([]);
    setSelectedOrder({});
    setPaxCount(1);
    setFoodServer("");
    handleSelectedTable(table);
    handleRemoveActiveAttending();

    recordUserActivityLog(`Clicked table no. ${table.table_no}`);

    let isOpenErrorModal = false;
    let isActiveLocal = false;
    let isTakeoutErrorModal = false;

    if (table.status === "attending") {
      // if (
      //   (!localIsAttending || table.id !== localIsAttending.id)
      // ) {
        confirmCancelAttending(table);
      // }
    } else if (table.status === "active") {
      isActiveLocal = await handleTableActivation(table, "attending",true);

      if(isActiveLocal){
        fetchOrderByTable(table);
      } else {
        setOpenPaxErrorCountModal(true)
        setTimeout(() => {
          recordUserActivityLog(
            `User ${getFullNameUser()} at Active table no. ${table.table_no} tried to use the table, but someone else was already using it.`
          );
        }, 1000)
      }
    } else if (
      (table.status === "inactive" && priceType === "store") ||
      table.status === "reserved"
    ) {
      if(table.status === "inactive"){
        isOpenErrorModal = await handleTableActivation(table, "attending", true);


        if(isOpenErrorModal){
          handlShowPaxCount({ show: true });
        }else {
          setOpenPaxErrorCountModal(true)
          setTimeout(() => {
            recordUserActivityLog(
              `User ${getFullNameUser()} at Inactive table no. ${table.table_no} tried to use the table, but someone else was already using it.`
            );
          }, 1000)
        }
      } else {
        handlShowPaxCount({ show: true });
      }
    } else if (table.status === "inactive" && priceType === "takeout") {
      if(table.status === "inactive"){
        isTakeoutErrorModal = await handleTableActivation(table, "attending", true);


        if(isTakeoutErrorModal){
          setShowCustomerModal(true);;
        }else {
          setOpenPaxErrorCountModal(true)
          setTimeout(() => {
            recordUserActivityLog(
              `User ${getFullNameUser()} at Takeout table no. ${table.table_no} tried to use the table, but someone else was already using it.`
            );
          }, 1000)
        }
      } else {
        setShowCustomerModal(true);;
      }

    } else {
      handleProductShow(true)
      // setShowProductOptions(true);
    }
  }

  function handleUpdatePaxCount() {
    setAction("update_pax");
    recordUserActivityLog(
      `Updated pax count of table no. ${selectedTable.table_no} to ${paxCount}`
    );
    if (selectedOrder && selectedOrder.id) {
      callPost(
        "orders/update_pax",
        { table: selectedTable.id, pax: paxCount },
        false,
        loggedInResto
      );
    } else {
      handlShowPaxCount(
        { 
          show: false, 
          type: "inactive", 
        }
      );
    }
  }

  function renderTableOptions() {
    // const attending_text = localIsAttending && selectedTable.status ===  localIsAttending.status ? {text: "YOU CLICKED", color: "green"} : {text: "ATTENDING", color: "red"}
    const attending_text = {text: "ATTENDING", color: "red"}

    return (
      <Row className="w-100 mt-2 category-container product-only-container">
        {allTables[priceType]?.map((table, index) => (
          <Col xs={12} md={8} lg={6} key={index}>
            {table.status === "attending" ? (
              <Badge.Ribbon text={attending_text.text} color={attending_text.color} placement="start">
                <Card
                  className={`mt-1 order-table-card ${priceType}-card ${
                    table.status === "active" && mergedTables.includes(table.id)
                      ? "table-merged"
                      : table.status === "attending"
                      ? "table-taken"
                      : table.status === "reserved"
                      ? "table-reservedd"
                      : ""
                  }`}
                  // onClick={() => {
                  //   if (!localIsAttending || (table.id !== localIsAttending?.id)) {
                  //     handleTableClick(table);
                  //   }
                  // }}
                >
                  {table.table_no?.toUpperCase()}
                </Card>
              </Badge.Ribbon>
            ) : table.order_status && table.order_status === "billed" ? (
              <Badge.Ribbon text="BILLED" color="cyan" placement="start">
                <Card
                  onClick={() => {
                    if (!disableTableClick) {
                      handleTableClick(table);
                    }
                  }}
                  className={`mt-1 order-table-card ${priceType}-card ${
                    table.status === "active" && mergedTables.includes(table.id)
                      ? "table-merged"
                      : table.status === "active"
                      ? "table-taken"
                      : table.status === "reserved"
                      ? "table-reserved"
                      : ""
                  }`}
                >
                  {table.table_no?.toUpperCase()}
                </Card>
              </Badge.Ribbon>
            ) : table.status === "reserved" ? (
              <Badge.Ribbon text="RESERVED" color="red" placement="start">
                <Card
                  onClick={() => {
                    if (!disableTableClick) {
                      handleTableClick(table);
                    }
                  }}
                  className={`mt-1 order-table-card ${priceType}-card ${
                    table.status === "active" && mergedTables.includes(table.id)
                      ? "table-merged"
                      : table.status === "active"
                      ? "table-taken"
                      : table.status === "reservedd"
                      ? "table-reserved"
                      : ""
                  }`}
                >
                  {table.table_no?.toUpperCase()}
                </Card>
              </Badge.Ribbon>
            ) : (
              <Card
                onClick={() => {
                  if (!disableTableClick) {
                    handleTableClick(table);
                  }
                }}
                className={`mt-1 order-table-card ${priceType}-card ${
                  table.status === "active" && mergedTables.includes(table.id)
                    ? "table-merged"
                    : table.status === "active"
                    ? "table-taken"
                    : table.status === "reserved"
                    ? "table-reservedd"
                    : ""
                }`}
              >
                {table.table_no?.toUpperCase()}
              </Card>
            )}
          </Col>
        ))}
      </Row>
    );
  }
  function renderProductOptions() {
    return (
      <div className="">
        <Row className="mt-2 overflow-scroll">
          {allCategories.map((category, categoryIndex) => (
            <>
              {priceType === 'takeout' ? 
                (
                  <>
                    {
                      category.name !== 'ramen' && 
                      category.name !== 'tsukemen' && (
                        <Col xs={12} lg={6} key={categoryIndex}>
                          <Button
                            onClick={() => {
                              // recordUserActivityLog(`Clicked category ${category.name}`)
                              setSelectedCategory(category.name);
                            }}
                            className={`category-btn w-100 mt-1 ${
                              selectedCategory === category.name
                                ? `${priceType}-clicked`
                                : `${priceType}`
                            } no-border`}
                          >
                            {category.name?.toUpperCase()}
                          </Button>
                        </Col>

                      )
                    }
                  </>
                ) : (
                  <Col xs={12} lg={6} key={categoryIndex}>
                    <Button
                      onClick={() => {
                        // recordUserActivityLog(`Clicked category ${category.name}`)
                        setSelectedCategory(category.name);
                      }}
                      className={`category-btn w-100 mt-1 ${
                        selectedCategory === category.name
                          ? `${priceType}-clicked`
                          : `${priceType}`
                      } no-border`}
                    >
                      {category.name?.toUpperCase()}
                    </Button>
                  </Col>
                )
              }
            </>
          ))}
        </Row>
        <Row
          className={`category-container product-only-container ${
            // showProductOptions ? " padding-bottom" : ""
            localShowProducts ? " padding-bottom" : ""
          }`}
        >
          {allProducts[selectedCategory]?.filter(item => item.is_modifier !== "1")?.map((product, productIndex) => (
            <Col xs={12} lg={8} key={productIndex} className="product-column">
              <Card
                title={
                  <div className="product-title">
                    <Row>{product.name?.toUpperCase()}</Row>
                    <Row>PHP {product[priceType + "_price"]}</Row>
                  </div>
                }
                className={`mt-1 product-card w-100 ${priceType}`}
              >
                {
                  product?.with_modifier === "0" ? (
                    <Row align="middle" justify="center">
                      <Col xs={8} className="text-center vertical-center">
                        <MinusCircleFilled
                          onClick={() =>
                            handleRemoveFromCart(product, productIndex)
                          }
                          className={`order-icon ${priceType}-icon`}
                        />
                      </Col>
                      <Col xs={8} className="text-center">
                        <Input
                          className="bigger-input-field text-center"
                          value={product[priceType + "_counter"]}
                          // defaultValue={product[priceType + "_counter"]}
                          onChange={(e) =>
                            handleManualQty(product, productIndex, e.target.value)
                          }
                        />
                      </Col>
                      <Col xs={8} className="text-center vertical-center">
                        <PlusCircleFilled
                          onClick={() => handleAddToCart(product, productIndex)}
                          className={`order-icon ${priceType}-icon`}
                        />
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col span={24} align="center"> 
                        <Button
                          onClick={() => handleOpenModifier(product)}
                          className="modifier-btn"
                        >
                          <Space>
                            <AddBoxIcon/>
                            MODIFIERS
                          </Space>
                        </Button>
                      </Col>
                    </Row>
                  )
                }
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    );
  }

  function renderOrderSlips() {
    return (
      <div 
        className="hide-from-screen"
      >
        {Object.keys(orderSlips).map((key, index) => {
          const printer_name = key.replace(/_.*/, ''); 
          return (
            <div key={index}>
              <DispatchSlip
                includeItemRemarks
                restoType={loggedInResto}
                purpose="order slip"
                printerName={printer_name}
                table={selectedTable.table_no}
                orderItems={orderSlips[key]}
                setBulkPrintRef={handleBulkPrintRef}
                pageAction={action}
              />
            </div>
          );
        })}
      </div>
    );
  }
  function renderCancelSlips() {
    return (
      <div className="hide-from-screen">
        {Object.keys(cancelSlips).map((key, index) => {
          return (
            <div key={index}>
              <DispatchSlip
                key={index}
                purpose="cancel"
                additionalItems={[]}
                printerName={key}
                table={selectedTable.table_no}
                orderItems={cancelSlips[key]}
                restoType={loggedInResto}
                setBulkPrintRef={handleBulkPrintRef}
              />
            </div>
          );
        })}
      </div>
    );
  }

  function renderVoidSlips() {
    return (
      <div className="hide-from-screen">
        {Object.keys(voidSlips).map((key, index) => {
          return (
            <div key={index}>
              <DispatchSlip
                key={index}
                purpose="void"
                additionalItems={[]}
                printerName={key}
                table={selectedTable.table_no}
                orderItems={voidSlips[key]}
                restoType={loggedInResto}
                setBulkPrintRef={handleBulkPrintRef}
              />
            </div>
          );
        })}
      </div>
    );
  }

  async function handleLogout() {
    const response = await logoutUser(restoType);
    if (response.data) {
      toast.success("Logging out...");
      setTimeout(() => {
        removeUserSession();
        navigate("/");
        refreshPage();
      }, 500);
    }
  }

  const handleOpenModifier = (data) => {
    setModifierData({
      ...data,
      addons: data.menu_modifiers
    })
    setModifierOrder((prev) => ({
      ...prev,
      modifier:[]
    }))
    setOpenModifier(true)
  }

  React.useEffect(() => {
    if (Object.keys(orderSlips).length > 0) {
      renderOrderSlips();
      setTimeout(() => {
        printMultipleOrderSlips(orderSlips, true, "order slips");
      }, 2000);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderSlips]);
  
  React.useEffect(() => {
    if (Object.keys(cancelSlips).length > 0) {
      renderCancelSlips();
      setTimeout(() => {
        printMultipleOrderSlips(cancelSlips, false, "cancel slips");
      }, 2000);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cancelSlips]);

  React.useEffect(() => {
    if (Object.keys(voidSlips).length > 0) {
      renderVoidSlips();
      setTimeout(() => {
        printMultipleOrderSlips(voidSlips, false, "void slips");
      }, 2000);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [voidSlips]);

  React.useEffect(() => {
    fetchAllTables();
    fetchAllBriqueProducts();
    // fetchAllEttasProducts();
  }, []);

  React.useEffect(() => {
    if (restoType ==="hanamaruken") {
      setAllProducts(allBriqueProducts);
      setAllCategories(briqueCategories);
      setSelectedCategory(briqueCategories[0]?.name);
    } else {
      // setAllProducts(allEttasProducts);
      // setAllCategories(ettasCategories);
      // setSelectedCategory(ettasCategories[0]?.name);
    }
  }, [restoType, localShowProducts]);

  React.useEffect(() => {
    var tempTotal = 0;
    orderCart?.forEach((item) => {
      let totalAmount =
        parseInt(item.counter) * parseFloat(item[item.pricelist + "_price"]);
      item.total = totalAmount;
      tempTotal += totalAmount;
    });
    setTotalAmount(tempTotal);
  }, [orderCart]);

  // HANDLE POST ACTIONS AFTER SUCCESSFUL CALLS TO POST APIS
  React.useEffect(() => {
    if (responseData) {
      if (action === "transfer") {
        // const printingData = [{ ref: transferRef, printer: "DISPATCH" }];
        // handleMultiplePrint(printingData);
        // handleAttendingTransfer(localAttendingTransfer, true)
        handleRemoveProduct();
        refreshPage();
      } else
      if (action === "reserve") {
        localStorage.setItem("open_pax_count", JSON.stringify(false));
        handleRemoveProduct();
        refreshPage();
      } else if (action === "split") {
        const printingData = [{ ref: splitRef, printer: "CASHIER" }];
        handleMultiplePrint(printingData);
      } else if (action === "update_pax") {
        handleRemoveActiveAttending({isRefresh: true})
      } else if (action === "merge") {
        handleHomeButton();
      } else {
        setTimeout(() => {
          refreshPage();
        }, 1000);
      }
    }
  }, [responseData]);

  React.useEffect(() => {
    if (putResponseData) {
      if (action === "billout") {
        // IF BILL OUT ANG ACTION
        const printingData = [{ ref: billOutRef, printer: "CASHIER" }];
        handleMultiplePrint(printingData);
      } else if (action === "void") {
        // IF VOID ANG ACTION
        const orderDeets = putResponseData.message;
        const tempOrderId = orderDeets.order_id;
        const tempDispatchItems = orderDeets.dispatch_slips[tempOrderId] || [];
        setDispatchItems(tempDispatchItems);

        const tempVoidedItems = [];
        Object.keys(orderDeets.order_slips).forEach((key, index) => {
          // if (key?.toLowerCase() !== "bar") {
            orderDeets.order_slips[key].forEach((item) => {
              var info = {
                ...item,
                counter: item.qty,
                name: item.menu_name,
              };
              tempVoidedItems.push(info);
            });
          // }
        });
        setVoidedItems(tempVoidedItems);

        if (
          tempDispatchItems &&
          tempDispatchItems.length > 0 &&
          tempVoidedItems.length > 0
        ) {
          const printingData = [{ ref: dispatchRef, printer: "DISPATCH" }];
          // const printingData = [{ ref: dispatchRef, printer: "CASHIER" }];
          setTimeout(() => {
            handleMultiplePrint(printingData);
          }, 1000);
        } else {
          setMultiplePrintDone(true);
        }
        // handleHomeButton();
        setVoidSlips(orderDeets.order_slips);
      } else if (action === "transfer") {
        // handleAttendingTransfer(localAttendingTransfer, true)
      } else if (action === "cancel") {
        // IF CANCEL ANG ACTION
        // const printingData = [
        //   { ref: cancelRef, printer: "CASHIER" },
        //   { ref: cancelRef, printer: "DISPATCH" },
        // ];
        // handleMultiplePrint(printingData);
        setCancelSlips(putResponseData.message.order_slips);
        setTimeout(() => {
          refreshPage();
        }, 1000);
      } else {
        setTimeout(() => {
          refreshPage();
        }, 1000);
      }
      handleRemoveProduct();
    }
    
  }, [putResponseData]);

  React.useEffect(() => {
    const tableOccupied = selectedTable.status === "active";
    if (tableOccupied && !localShowAddItem) {
      setOrderCart([]);
    }
  }, [priceType]);

  // ENHANCEMENT: Refresh page only when the priting is done
  React.useEffect(() => {
    if (
      action === "order" ||
      action === "add-item" ||
      action === "cancel" ||
      action === "void"
    ) {
      if (multiplePrintDone && printSlipsDone) {
        setTimeout(() => {
          refreshPage();
        }, 2500);
      }
    } else {
      if (multiplePrintDone) {
        setTimeout(() => {
          refreshPage();
        }, 2000);
      }
    }
  }, [action, multiplePrintDone, printSlipsDone]);

  React.useEffect(() => {
    let intervalId;
    if (
      location.pathname === "/orderingpage" &&
      // !showProductOptions &&
      !localShowProducts &&
      !showCustomerModal &&
      !openTransferModal &&
      !openRemarksModal &&
      !openMergeModal &&
      !openVoidModal &&
      !openSplitModal &&
      !openPaxCountModal
    ) {
      fetchAllTables();
      intervalId = setInterval(fetchAllTables, 2000);
    }

    // Clean up the interval when the component unmounts or the location changes
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [
    location.pathname,
    // showProductOptions,
    localShowProducts,
    showCustomerModal,
    openTransferModal,
    openRemarksModal,
    openMergeModal,
    openVoidModal,
    openSplitModal,
    openPaxCountModal,
  ]);

  React.useEffect(() => {
    if (localOrderShow) {
      setSelectedOrder(localOrderShow.order);
      setPaxCount(localOrderShow.order.pax);
      setFoodServer(localOrderShow.order.food_server);
      const tempOrders = localOrderShow?.order_details
        ? localOrderShow?.order_details.map((item) => {
            return {
              id: item.id,
              menu_id: item.menu_id,
              name: item.menu_name,
              menu_name: item.menu_name,
              counter: item.qty,
              price: item.price,
              [item.pricelist + "_price"]: item.price,
              max_qty: item.qty,
              qty: item.qty,
              pricelist: item.pricelist,
              total: parseFloat(item.price) * parseInt(item.qty),
              remarks: item.remarks,
              addons: item.addons,
              menu_modifier: item.addons,
              menu_details: item.menu_details,
              with_modifier: item.with_modifier,
              with_modifier_total: item.price,
            };
          })
        : [];
      setOrderCart(tempOrders);
      setOrderItems(tempOrders);
      setDispatchItems(tempOrders)
      // }
    } else {
      setOrderCart([]);
      setOrderItems([]);
      setSelectedOrder({});
    }
  }, []);

  return (
    <div className="no-scrol">
      <Row className="px-3 pt-2 pb-1">
        <Col xs={24} lg={15} className="product-side-container px-2">
          <Row className="">
            {localShowProducts ? (
              <Tabs
                defaultActiveKey={tabDefaultValue}
                // activeKey={restoType}
                className="resto-tabs"
                type="card"
                size="medium"
                onChange={(e) => {
                  recordUserActivityLog(`Clicked restaurant tab ${e}`);
                  setRestoType(e);
                }}
                items={["hanamaruken",].map((branch) => {
                  return {
                    label: branch,
                    key: branch,
                  };
                })}
              />
            ) : (
              <Title
                className="mt-2"
                level={3}
              >{`Hello, ${getFullNameUser()}! 👋`}</Title>
            )}
            <Button
              onClick={() => {
                handleDisableAttending()
              }}
              className="ms-auto"
            >
              <span className="d-flex align-items-center">
                {loading ? "Refreshing..." : "Refresh Table"}
                {loading && (
                  <span className="spinner-border spinner-border-sm ms-2"></span>
                )}
              </span>
            </Button>
          </Row>
          <Row
            className={`${localShowProducts && !localShowAddItem ? "mt-0" : ""}`}
          >
            {priceTypes.map((type) => (
              <Col lg={4} key={type}>
                {
                  type === "store" || type === "takeout" ? (
                    <Button
                      onClick={() => {
                        recordUserActivityLog(`Clicked price type ${type}`);
                        setPriceType(type);
                      }}
                      className={`w-100 pricetype-btn ${type} ${
                        priceType === type ? `${priceType}-clicked` : ""
                      }`}
                    >
                      {type && type === "store" ? "DINE IN" : type.toUpperCase()}
                    </Button>
                  ) : (
                    <Button
                      disabled={true}
                      className="w-100 btn-disable"
                    >
                      {type && type === "store" ? "DINE IN" : type.toUpperCase()}
                    </Button>
                  )
                }
              </Col>                
            ))}
          </Row>
          {localShowProducts ? renderProductOptions() : renderTableOptions()}
        </Col>
        <Col xs={24} lg={9}>
          <Card
            title={
              <div>
                <Row className="d-flex justify-content-between w-100">
                  <Col className="">ORDER STATUS</Col>
                  {((selectedTable?.qrcode !== "E-00" &&
                    selectedTable?.qrcode !== "B-00" &&
                    selectedTable?.id &&
                    selectedTable?.status === "active" &&
                    !localShowAddItem) ||
                    (mergedTables.includes(selectedTable.id) &&
                      orderCart &&
                      orderCart.length === 0)) && (
                    <Col className="d-flex justify-content-end">
                      <Button
                        type="primary"
                        className="w-100"
                        onClick={() => {
                          recordUserActivityLog(
                            `Clicked add item for table ${selectedTable.table_no}`
                          );
                          setAction("add-item");
                          // setShowAddItem(true);
                          handleShowAddItem(true)
                          // setShowProductOptions(true);
                          handleProductShow(true);
                        }}
                        disabled={!selectedOrder.id}
                      >
                        ADD ITEM
                      </Button>
                    </Col>
                  )}
                </Row>
                {selectedTable && selectedTable.table_no && (
                  <>
                    <Row>
                      {` Table # ${selectedTable.table_no} | Guest Count: ${paxCount}`}
                      {selectedOrder &&
                        !selectedOrder.has_discounts &&
                        orderItems?.length > 0 && (
                          <EditOutlined
                            className="ms-2 pointer"
                            onClick={() => {
                              setAction("open_update_pax");
                              handlShowPaxCount({ show: true });
                            }}
                          />
                        )}
                    </Row>
                    <Row>{` Food Server: ${foodServer ?? ""}`}</Row>
                    <Row>
                      <Col>
                        {selectedOrder && selectedOrder.added_on
                          ? `${moment(selectedOrder.added_on).format(
                              "hh:mm A"
                            )}`
                          : ""}
                      </Col>
                    </Row>
                  </>
                )}
                {takeoutCustomerDetails.name &&
                  takeoutCustomerDetails.contact_no && (
                    <Row>{`${takeoutCustomerDetails.name ?? ""} | ${
                      takeoutCustomerDetails.contact_no ?? ""
                    }`}</Row>
                  )}
              </div>
            }
            className="order-status-container"
          >
            <Row className="d-flex justify-content-between header">
              <Col xs={14}>ITEM</Col>
              <Col xs={3} className="text-center">
                QTY
              </Col>
              <Col xs={5} className="text-end">
                PRICE
              </Col>
              <Col xs={2}></Col>
            </Row>
            <Divider />
            <div className="cart-container">
              {orderCart?.map((item, index) => (
                <div>
                  <Row
                    className="d-flex justify-content-between mt-2"
                    key={index}
                  >
                    <Col xs={11}>
                      <Row>
                        {item.name} {item.pricelist === "takeout" ? " 🥡" : ""}
                      </Row>
                      {
                        item.menu_details && item.menu_details?.length !== 0 && (
                          <>
                            {
                              item.menu_details.map((data) => (
                                <Row className="ms-4">
                                  {data?.name}
                                </Row>
                              ))
                            }
                          </>
                        )
                      }
                      {
                        item?.with_modifier === "1" && (
                          <>
                            {
                              item.addons.map((data) => (
                                <Row className="ms-4">
                                  {data?.modifier_name} - {data.price}
                                </Row>
                              ))
                            }
                          </>
                        )
                      }
                    </Col>
                    <Col xs={5} className="text-center">
                      {item.counter}
                    </Col>
                    <Col xs={5} className="text-center">
                      {
                        !item?.with_modifier || item.with_modifier === "0" ? (
                        formatAmount(
                          parseFloat(item[item.pricelist + "_price"]) * parseFloat(item.counter)
                        )
                      ) : (
                        formatAmount(
                          parseFloat(item.with_modifier_total) * parseFloat(item.counter)
                        )
                      )}
                    </Col>
                    {selectedTable.status === "inactive" && !localShowAddItem && (
                      <Col xs={2} className="trash-icon-container">
                        <DeleteOutlined
                          className="trash-icon me-2"
                          onClick={() => handleDeleteFromCart(item)}
                        />
                        <EditOutlined
                          onClick={() => {
                            setTempRemarks(item.remarks);
                            setOrderCartIndex(index);
                            setOpenRemarksModal(true);
                          }}
                        />
                      </Col>
                    )}
                    {selectedTable.status === "active" &&
                      localShowAddItem &&
                      item.is_additional && (
                        <Col xs={2} className="trash-icon-container">
                          <DeleteOutlined
                            className="trash-icon me-2"
                            onClick={() => handleDeleteFromCart(item)}
                          />
                          <EditOutlined
                            onClick={() => {
                              setTempRemarks(item.remarks);
                              setOrderCartIndex(index);
                              setOpenRemarksModal(true);
                            }}
                          />
                        </Col>
                      )}
                  </Row>
                  {item.remarks && !isEmptyString(item.remarks) && (
                    <Row className="item-remarks-container">
                      <EditNoteOutlined className="item-remarks-icon" />
                      {item.remarks}
                    </Row>
                  )}
                </div>
              ))}
            </div>
            <div className="order-footer-container">
              <Divider />
              <Row className="d-flex justify-content-between">
                <Col className="">
                  <h3>TOTAL</h3>
                </Col>
                <Col className="text-end">
                  <h3>{formatAmount(totalAmount)}</h3>
                </Col>
              </Row>
              {(
                (
                  selectedTable.status === "active" && !localShowAddItem
                )
              ) && (
                <Row className="dinein-actions">
                  <Col xs={8}>
                    <Button
                      className="w-100 mt-1"
                      onClick={() => {
                        recordUserActivityLog(
                          `Clicked settle for table no. ${selectedTable.table_no}`
                        );
                        if (selectedOrder.id) {
                          navigate("/add-payment/" + selectedOrder.id);
                        }
                        handlShowPaxCount(
                          { 
                            show: false, 
                            type: "attending", 
                            isOrder: false, 
                            isRemove: true 
                          }
                        );
                      }}
                      disabled={
                        !orderCart ||
                        orderCart?.length === 0 ||
                        selectedTable?.qrcode === "E-00" ||
                        selectedTable?.qrcode === "B-00"
                      }
                    >
                      SETTLE
                    </Button>
                  </Col>
                  <Col xs={8}>
                    <Button
                      className="mt-1 w-100"
                      onClick={() => {
                        setAction("void");
                        recordUserActivityLog(
                          `Clicked void for table no. ${selectedTable.table_no}`
                        );
                        setOpenVoidModal(true);
                        handleTableActivation(selectedTable, "attending",false);
                      }}
                      // disabled={mergedTables.includes(selectedTable.id)}
                      disabled={!orderCart || orderCart?.length === 0}
                    >
                      VOID
                    </Button>
                  </Col>
                  <Col xs={8}>
                    <Button
                      className="mt-1 w-100"
                      onClick={() => {
                        recordUserActivityLog(
                          `Clicked merge for table no. ${selectedTable.table_no}`
                        );
                        setAction("merge");
                        setOpenMergeModal(true);
                        handleTableActivation(selectedTable, "attending",false);
                      }}
                      disabled={
                        mergedTables.includes(selectedTable.id) ||
                        selectedTable?.qrcode === "E-00" ||
                        selectedTable?.qrcode === "B-00" ||
                        selectedTable?.order_status === "billed"
                      }
                    >
                      MERGE
                    </Button>
                  </Col>
                  <Col xs={8}>
                    <Button
                      className="mt-1 w-100"
                      disabled={
                        selectedOrder.status === "" ||
                        parseFloat(selectedOrder.pax) <= 1 ||
                        mergedTables.includes(selectedTable.id) ||
                        selectedTable?.qrcode === "E-00" ||
                        selectedTable?.qrcode === "B-00"
                      }
                      onClick={() => {
                        setAction("split");
                        recordUserActivityLog(
                          `Clicked split for table no. ${selectedTable.table_no}`
                        );
                        setOpenSplitModal(true);
                        handleTableActivation(selectedTable, "attending",false);
                      }}
                    >
                      SPLIT
                    </Button>
                  </Col>
                  <Col xs={8}>
                    <Button
                      className="mt-1 w-100"
                      disabled={
                        selectedOrder.status === "" ||
                        selectedOrder.status === "billed" ||
                        mergedTables.includes(selectedTable.id) ||
                        selectedTable?.qrcode === "E-00" ||
                        selectedTable?.qrcode === "B-00"
                      }
                      onClick={() => {
                        recordUserActivityLog(
                          `Clicked transfer for table no. ${selectedTable.table_no}`
                        );
                        setAction("transfer");
                        setOpenTransferModal(true);
                        handleTableActivation(selectedTable, "attending",false);
                      }}
                    >
                      TRANSFER
                    </Button>
                  </Col>
                  <Col span={8}>
                    <Button
                      className="mt-1 w-100"
                      disabled={
                        dispatchItems?.length === 0                        
                      }
                      onClick={() => {
                        setAction("split");
                        recordUserActivityLog(
                          `Clicked reprint for table no. ${selectedTable.table_no}`
                        );
                        setOpenReprintModal(true);
                        handleTableActivation(selectedTable, "attending",false);
                      }}
                    >
                      REPRINT
                    </Button>
                  </Col>
                  {/* <Col span={8}>
                    <Button
                      className="mt-1 w-100"
                      disabled={
                        dispatchItems?.length === 0                        
                      }
                      onClick={() => {
                        recordUserActivityLog(
                          `Clicked Reprint Dispatch for table no. ${selectedTable.table_no}`
                        );
                        handleReprintDispatch();
                      }}
                    >
                      DISPATCH
                    </Button>
                  </Col> */}
                  <Col xs={24} align="center">
                    <Button
                      danger
                      className="mt-4 w-50"
                      onClick={() => {
                        setAction("cancel");
                        recordUserActivityLog(
                          `Clicked cancel for table no. ${selectedTable.table_no}`
                        );
                        if (userRole === "1" || userRole === "7") {
                          confirmCancel();
                        } else {
                          setOpenAuthentication(true);
                        }
                      }}
                      disabled={
                        selectedOrder.status === "" ||
                        (mergedTables.includes(selectedTable.id) &&
                          (!orderCart || orderCart?.length === 0)) ||
                        selectedOrder.status === "billed" ||
                        selectedTable?.qrcode === "E-00" ||
                        selectedTable?.qrcode === "B-00"
                      }
                    >
                      CANCEL
                    </Button>
                  </Col>
                </Row>
              )}
              {selectedTable.status === "inactive" &&
                orderCart?.length > 0 &&
                !localShowAddItem && (
                  <>
                    <Row className="d-flex justify-content-center mt-1">
                      <Button
                        onClick={handleSubmitOrder}
                        type="primary"
                        className="order-now-btn w-50"
                        loading={isLoading || putIsLoading || isSaving}
                        disabled={isLoading || putIsLoading || isSaving}
                      >
                        ORDER NOW
                      </Button>
                    </Row>
                    {/* <Row className="d-flex justify-content-center mt-1">
                      {
                        isClicked ? (
                          <Button
                          onClick={handleSubmitTest}
                          type="primary"
                          className="order-now-btn w-50"
                          loading={isWsProgress}
                          disabled={isWsProgress}
                        >
                          You Clicked
                        </Button>
                        ) : (
                          <Button
                          onClick={handleSubmitTest}
                          type="primary"
                          className="order-now-btn w-50"
                          loading={isLoading || putIsLoading || isSaving || isWsProgress}
                          disabled={isLoading || putIsLoading || isSaving || isWsProgress}
                        >
                          {isWsProgress ? 'Someone Clicked' : 'ORDER TEST'}
                        </Button>
                        )
                      }
                    </Row> */}
                  </>
                )}
              {localShowAddItem && (
                <>
                  <Row className="d-flex justify-content-center">
                    <Button
                      type="primary"
                      className="w-75"
                      onClick={handleAdditionalItems}
                      loading={isLoading || putIsLoading || isSaving}
                      disabled={
                        isLoading ||
                        putIsLoading ||
                        isSaving ||
                        additionalItems.length === 0
                      }
                    >
                      ORDER NOW
                    </Button>
                  </Row>
                </>
              )}
              {(selectedTable.status === "inactive" || localShowAddItem) && (
                <>
                  <Row className="d-flex justify-content-center mt-2">
                    <Button
                      className={`${
                        localShowAddItem ? "w-75" : "order-now-btn w-50"
                      }`}
                      onClick={() => {
                        if (!localShowAddItem) {
                          recordUserActivityLog(
                            `Unclicked table no. ${selectedTable.table_no}`
                          );
                        } else {
                          recordUserActivityLog(
                            `Cancelled add item for table no. ${selectedTable.table_no}`
                          );
                        }
                        handleHomeButton();
                      }}
                    >
                      BACK
                    </Button>
                  </Row>
                </>
              )}
            </div>
          </Card>
        </Col>
      </Row>
      <Row className="ordering-navbar">
        <Col className="d-flex justify-content-center">
          <WidgetsIcon
            className={
              userRole === "8" || userRole === "2" ? "footer-icon-disabled" : "footer-icon"
            }
            onClick={() => {
              if(userRole !== "2"){
                recordUserActivityLog(`Clicked sales report navigation icon`);
                if (!isLoading && !putIsLoading && !isSaving) {
                  // if (selectedTable?.status === "inactive" && !localShowAddItem) {
                  //   handleTableActivation(selectedTable, "inactive");
                  // }
                  handleHomeButton();
                  if (userRole !== "8") {
                    navigate("/sales-report");
                  }
                }
              }
            }}
          />
        </Col>
        <Col className="d-flex justify-content-center">
          <HomeIcon
            className="footer-icon"
            onClick={(e) => {
              recordUserActivityLog(`Clicked home navigation icon`);
              // this fixes the problem with double ordersss
              if (!isLoading && !putIsLoading && !isSaving) {
                // if (selectedTable?.status === "inactive" && !localShowAddItem) {
                //   handleTableActivation(selectedTable, "inactive");
                // }
                handleHomeButton();
                setTimeout(() => {
                  refreshPage();
                  navigate("/orderingpage");
                }, 500);
              }
            }}
          />
        </Col>
        <Col className="d-flex justify-content-center">
          <PaidIcon
            className={
              userRole !== "8" ? "footer-icon" : "footer-icon-disabled"
            }
            onClick={() => {
              recordUserActivityLog(`Clicked cash count navigation icon`);
              if (!isLoading && !putIsLoading && !isSaving) {
                // if (selectedTable.status === "inactive" && !localShowAddItem) {
                //   handleTableActivation(selectedTable, "inactive");
                // }
                handleHomeButton();
                if (userRole !== "8") {
                  navigate("/add-cash-count", { state: { name: "cashier" } });
                }
              }
            }}
          />
        </Col>
        <Col className="d-flex justify-content-center">
          <PointOfSaleIcon
            className={
              userRole === "1" ? "footer-icon" : "footer-icon-disabled"
            }
            onClick={() => {
              if (userRole === "1") {
                recordUserActivityLog(`Clicked cash drawer navigation icon`);
                if (!isLoading && !putIsLoading && !isSaving) {
                  // if (selectedTable.status === "inactive" && !localShowAddItem) {
                  //   handleTableActivation(selectedTable, "inactive");
                  // }
                  handleHomeButton();
                  if (userRole === "1") {
                    handleOpenCashDrawer();
                  }
                }
              }
            }}
          />
        </Col>
        <Col className="d-flex justify-content-center">
          <LogoutOutlined
            className="footer-icon"
            onClick={() => {
              recordUserActivityLog(`Clicked logout navigation icon`);
              if (!isLoading && !putIsLoading && !isSaving) {
                // if (selectedTable.status === "inactive" && !localShowAddItem) {
                //   handleTableActivation(selectedTable, "inactive");
                // }
                handleRemoveActiveAttending();
                setTimeout(() => {
                  handleLogout();
                }, 1000)
              }
            }}
          />
        </Col>
      </Row>

      {/* Modal to Add Number of Pax */}
      <Modal
        footer={null}
        closeIcon={false}
        maskClosable={false}
        open={openPaxCountModal}
      >
        {
          selectedTable.status === "reserved" ? (
            <>
              <Row>Table {selectedTable.table_no} has been reserved!</Row>
            </>
          ) : (
            <>
              <Row>NUMBER OF PAX</Row>
              <Row className="mt-2">
                <Input
                  className="bigger-input-field h-100"
                  min={1}
                  defaultValue={paxCount}
                  type="number"
                  onChange={(e) => setPaxCount(e.target.value)}
                />
              </Row>
              {
                action !== "open_update_pax" && (
                  <>
                    <Row className="mt-4">FOOD SERVER</Row>
                    <Row className="mt-2">
                      <Input
                        className="bigger-input-field h-100"
                        value={foodServer}
                        type="text"
                        autoComplete="on"
                        onChange={(e) => setFoodServer(e.target.value)}
                      />
                    </Row>
                  </>
                )
              }
            </>
          )
        }
        <Space className="d-flex justify-content-end w-100 p-0 mt-3">
          <Button
            className="me-2 px-3"
            onClick={() => {
              recordUserActivityLog(
                `Unclicked table no. ${selectedTable.table_no}`
              );
              handlShowPaxCount(
                { 
                  show: false, 
                  type: selectedTable.status, 
                }
              );
              setDisableTableClick(false);
            }}
          >
            Cancel
          </Button>
          {selectedTable.status === "reserved" && (
            <Button
              className="px-3"
              onClick={() => handleTableReservation("inactive")}
              danger
            >
              CANCEL RESERVATION
            </Button>
          )}
          {selectedTable.status === "inactive" && !localShowProducts && (
            <>
              <Button
                type="primary"
                className="px-3"
                onClick={() => handleTableReservation("reserved")}
              >
                RESERVE TABLE
              </Button>
              <Button
                type="primary"
                className="px-3"
                onClick={() => {
                  recordUserActivityLog(
                    `Clicked order button for table ${selectedTable.table_no}`
                  );
                  handlShowPaxCount(
                    { 
                      show: false, 
                      type: "attending", 
                      isOrder: true, 
                    }
                  );
                  // setShowProductOptions(true);
                  handleProductShow(true)
                }}
                disabled={!paxCount || parseFloat(paxCount) === 0}
              >
                ORDER
              </Button>
            </>
          )}
          {(selectedTable.status === "active" || localShowProducts) && (
            <Button
              type="primary"
              className="px-3"
              onClick={handleUpdatePaxCount}
            >
              UPDATE
            </Button>
          )}
        </Space>
      </Modal>

      {/* VOID & CANCEL AUTHENTICATION MODAL */}
      <AuthenticationModal
        onShow={openAuthentication}
        onCancel={() => setOpenAuthentication(false)}
        onSubmit={action === "void" ? handleVoidOrder : handleCancelOrder}
        action={action}
        subject="order"
      />

      {/* MODAL FOR VOIDING AND SPLITTING ITEMS */}
      <Modal
        centered
        footer={null}
        closeIcon={false}
        maskClosable={false}
        open={openVoidModal || openSplitModal || openReprintModal}
        width={800}
        title={
          openVoidModal ? (
            "VOID ITEMS"
          ) : openReprintModal ? (
            "REPRINT ITEMS"
          ) : (
            <Row className="d-flex justify-content-between">
              <Col>SPLIT ITEMS</Col>
              <Col className="text-end">NO. OF PAX: {selectedOrder.pax}</Col>
            </Row>
          )
        }
      >
        <hr />
        <Row className="">
          <Col xs={11} className=""></Col>
          <Col className="modal-text">
            QTY TO {
              openVoidModal ? "VOID" :
              openReprintModal ? 
                "REPRINT" 
                : 
                "SPLIT"
            }
          </Col>
        </Row>
        {orderItems?.map((item, index) => (
          <div key={index}>
            <Row className="d-flex justify-content-between mt-2">
              <Col xs={6} className="modal-text">
                {item.name}
              </Col>
              <Col xs={1}>
                <MinusCircleFilled
                  className="modal-icon"
                  onClick={() => {
                    setOrderItems((prev) => {
                      const updatedOptions = [...prev];
                      if (parseInt(updatedOptions[index].counter) - 1 > 0) {
                        setItemsToVoid([...itemsToVoid, item.id]);
                        updatedOptions[index] = {
                          ...updatedOptions[index],
                          counter: parseInt(updatedOptions[index].counter) - 1,
                        };
                      } else if (
                        parseInt(updatedOptions[index].counter) - 1 ===
                        0
                      ) {
                        updatedOptions[index] = {
                          ...updatedOptions[index],
                          counter: parseInt(updatedOptions[index].counter) - 1,
                        };
                        const newItems = itemsToVoid.filter(
                          (data) => data !== item.id
                        );
                        setItemsToVoid(newItems);
                      }
                      return updatedOptions;
                    });
                  }}
                />
              </Col>
              <Col xs={2}>
                <InputNumber
                  // type="number"
                  className="modal-text"
                  value={item.counter}
                  // max={parseInt(item.max_qty)}
                  onChange={(e) => {
                    setOrderItems((prev) => {
                      const updatedOptions = [...prev];
                      updatedOptions[index] = {
                        ...updatedOptions[index],
                        counter: e,
                      };
                      return updatedOptions;
                    });
                    if (
                      parseInt(e) > 0 &&
                      parseInt(e) <= parseInt(item.max_qty)
                    ) {
                      setItemsToVoid([...itemsToVoid, item.id]);
                    } else {
                      const newItems = itemsToVoid.filter(
                        (data) => data !== item.id
                      );
                      setItemsToVoid(newItems);
                    }
                  }}
                />
              </Col>
              <Col xs={1}>
                <PlusCircleFilled
                  className="modal-icon"
                  onClick={() => {
                    setItemsToVoid([...itemsToVoid, item.id]);
                    setOrderItems((prev) => {
                      const updatedOptions = [...prev];
                      if (
                        parseInt(updatedOptions[index].counter) + 1 <=
                        parseInt(updatedOptions[index].max_qty)
                      ) {
                        updatedOptions[index] = {
                          ...updatedOptions[index],
                          counter: parseInt(updatedOptions[index].counter) + 1,
                        };
                      } else if (
                        parseInt(updatedOptions[index].counter) ===
                        parseInt(updatedOptions[index].max_qty)
                      ) {
                        // do nothing but don't remove this condition
                      } else {
                        const newArray = itemsToVoid.filter(
                          (voidItem) => voidItem !== item.id
                        );
                        setItemsToVoid(newArray);
                      }
                      return updatedOptions;
                    });
                  }}
                />
              </Col>
              <Col xs={2}>
                <Checkbox
                  className="modal-checkbox"
                  checked={itemsToVoid.includes(item.id)}
                  onChange={(e) => {
                    if (
                      e.target.checked &&
                      parseInt(item.counter) > 0 &&
                      parseInt(item.counter) <= parseInt(item.max_qty)
                    ) {
                      setItemsToVoid([...itemsToVoid, item.id]);
                    } else {
                      const newArray = itemsToVoid.filter(
                        (voidItem) => voidItem !== item.id
                      );
                      setItemsToVoid(newArray);
                    }
                  }}
                />
              </Col>
            </Row>
            {item.remarks && !isEmptyString(item.remarks) && (
              <Row className="item-remarks-container">
                <EditNoteOutlined className="item-remarks-icon" />
                {item.remarks}
              </Row>
            )}
          </div>
        ))}
        {openSplitModal && (
          <>
            <Row className="mt-3 modal-text">
              <Col xs={10} className="my-auto">
                NUMBER OF PAX FOR THIS SPLIT
              </Col>
              <Col xs={6} className="">
                <Input
                  type="number"
                  min={1}
                  max={parseFloat(selectedOrder.pax) - 1}
                  defaultValue={paxCount}
                  className="bigger-input-field w-100"
                  onChange={(e) => setPaxCount(e.target.value)}
                />
              </Col>
            </Row>
          </>
        )}
        <hr />
        <Space className="d-flex justify-content-end w-100 p-0 mt-3">
          <Button
            className="me-2 px-3 bigger-btn"
            onClick={() => {
              handleRemoveActiveAttending({isRefresh: true});
              if (openSplitModal) {
                recordUserActivityLog(`Clicked cancel split modal`);
              } else {
                recordUserActivityLog(`Clicked cancel void modal`);
              }
              setItemsToVoid([]);
              setOpenVoidModal(false);
              setOpenSplitModal(false);
            }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            className="px-3 bigger-btn"
            onClick={() => {
              setShowLoader(true)
              if (openVoidModal) {
                recordUserActivityLog(
                  `Clicked proceed to void items in table ${selectedTable.table_no}`
                );
                if (userRole === "1" || userRole === "7") {
                  handleVoidOrder();
                } else {
                  setOpenAuthentication(true);
                }
              } else if (openReprintModal) {
                recordUserActivityLog(
                  `Clicked proceed to reprint items in table ${selectedTable.table_no}`
                );
                handleReprintOrder();
              } else {
                recordUserActivityLog(
                  `Clicked proceed to split items in table ${selectedTable.table_no}`
                );
                handleSplitOrder();
              }
              setTimeout(() => (
                setShowLoader(false)
              ), 2000)
            }}
            disabled={
              itemsToVoid.length === 0 ||
              (openSplitModal &&
                parseFloat(paxCount) >= parseInt(selectedOrder.pax)) ||
              (openSplitModal && parseFloat(paxCount) < 1) ||
              showLoader
            }
          >
            Proceed
          </Button>
        </Space>
      </Modal>

      {/* MERGING  TABLE MODAL */}
      <Modal
        centered
        open={openMergeModal}
        onCancel={() => {
          setOpenMergeModal(false);
          setTableIdToMerge([]);
          setTablesToMerge([]);
        }}
        width={800}
        footer={null}
        maskClosable={false}
      >
        <>
          <Title level={5}>SELECT TABLES TO MERGE</Title>
          <Row>
            {allTables[priceType]?.map(
              (table, index) =>
                table.status === "active" &&
                table.id !== selectedTable.id &&
                (table.merge_to === null || table.merge_to === '') &&
                table.order_status !== "billed" && (
                  <Col
                    key={index}
                    lg={6}
                    xs={12}
                    className={`mt-3 table-cards ${
                      tableIdToMerge.includes(table.id)
                        ? ""
                        : "taken-table-card"
                    }`}
                    onClick={() => {
                      if (table.id === selectedTable.id) {
                        // do nothing to the selected table to merge
                      } else {
                        if (tableIdToMerge.includes(table.id)) {
                          const newIdArray = tableIdToMerge.filter(
                            (item) => item !== table.id
                          );
                          setTableIdToMerge(newIdArray);
                          const newArray = tablesToMerge.filter(
                            (item) => item.id !== table.id
                          );
                          setTablesToMerge(newArray);
                        } else {
                          setTableIdToMerge([...tableIdToMerge, table.id]); // stores only the table ID
                          setTablesToMerge([...tablesToMerge, table]); //store the entire tabke info
                        }
                      }
                    }}
                  >
                    <Card className={`${priceType}-clicked`}>
                      <Title level={3}>{table.table_no}</Title>
                    </Card>
                  </Col>
                )
            )}
          </Row>
        </>
        <hr />
        <Space className="d-flex justify-content-end w-100 p-0 mt-3">
          <Button
            className="me-2 px-4 py-3"
            onClick={() => {
              recordUserActivityLog(
                `Clicked cancel merge table ${selectedTable.table_no}`
              );
              handleRemoveActiveAttending({isRefresh: true});
              setOpenMergeModal(false);
              setTableIdToMerge([]);
              setTablesToMerge([]);
            }}
          >
            CANCEL
          </Button>
          <Button
            type="primary"
            className="px-4 py-3"
            onClick={confirmMerge}
            disabled={tableIdToMerge.length === 0}
          >
            MERGE
          </Button>
        </Space>
      </Modal>

      {/* TRANSFER TABLE MODAL */}
      <Modal
        centered
        open={openTransferModal}
        onCancel={() => {
          setOpenTransferModal(false);
          setRecipientTable({});
          setOpenTransferItemOptions(false);
          setOpenTransferTableOptions(false);
        }}
        width={800}
        footer={null}
        maskClosable={false}
      >
        {!openTransferItemOptions && !openTransferTableOptions && (
          <>
            <Title level={5}>TRANSFER</Title>
            <Row>
              <Col
                xs={12} sm={12} md={24} lg={6} xl={24}
                className={`mt-3 table-cards`}
                onClick={() => {
                  setOpenTransferTableOptions(true);
                }}
                align="center"
              >
                <Card className={`${priceType}-clicked`}>
                  <Title level={3}>TABLE</Title>
                </Card>
              </Col>
              {/* <Col
                lg={6}
                xs={12}
                className={`mt-3 table-cards `}
                onClick={() => {
                  setOpenTransferItemOptions(true);
                }}
              >
                <Card className={`${priceType}-clicked`}>
                  <Title level={3}>ITEMS</Title>
                </Card>
              </Col> */}
            </Row>
          </>
        )}
        {openTransferTableOptions && (
          <>
            <Title level={5}>
              SELECT TABLE TO TRANSFER TABLE #{selectedTable.table_no} INTO
            </Title>
            <Row>
              {/* {allTables[priceType]?.filter(item => item.status !== "attending" && item.status !== "active").map((table, index) => { */}
              {allTables[priceType]?.filter(item => item.status !== "active").map((table, index) => {
                if (table.status === "inactive") {
                  return (
                    <Col
                      key={index}
                      lg={6}
                      xs={12}
                      className={`mt-3 table-cards ${
                        table.id === recipientTable.table_id
                          ? ""
                          : "taken-table-card"
                      }`}
                      onClick={() => {
                        // handleAttendingTransfer(table)
                        if (table.id === recipientTable.table_id) {
                          // do nothing to the selected table to merge
                        } else {
                          setRecipientTable({
                            table_id: table.id,
                            table_no: table.table_no,
                          });
                        }
                      }}
                    >
                      <Card className={`${priceType}-clicked`}>
                        <Title level={3}>{table.table_no}</Title>
                      </Card>
                    </Col>
                  );
                }
              })}
            </Row>
          </>
        )}
        {openTransferItemOptions && (
          <>
            <Title level={5}>SELECT ITEMS TO TRANSFER</Title>
            <Row className="">
              <Col xs={11} className=""></Col>
              <Col className="modal-text">QTY TO TRANSFER</Col>
            </Row>
            {orderItems?.map((item, index) => (
              <Row key={index} className="d-flex justify-content-between mt-2">
                <Col xs={6} className="modal-text">
                  {item.name}
                </Col>
                <Col xs={1}>
                  <MinusCircleFilled
                    className="modal-icon"
                    onClick={() => {
                      setOrderItems((prev) => {
                        const updatedOptions = [...prev];
                        if (parseInt(updatedOptions[index].counter) - 1 > 0) {
                          setItemsToVoid([...itemsToVoid, item.id]);
                          updatedOptions[index] = {
                            ...updatedOptions[index],
                            counter:
                              parseInt(updatedOptions[index].counter) - 1,
                          };
                        } else if (
                          parseInt(updatedOptions[index].counter) - 1 ===
                          0
                        ) {
                          updatedOptions[index] = {
                            ...updatedOptions[index],
                            counter:
                              parseInt(updatedOptions[index].counter) - 1,
                          };
                          const newItems = itemsToVoid.filter(
                            (data) => data !== item.id
                          );
                          setItemsToVoid(newItems);
                        }
                        return updatedOptions;
                      });
                    }}
                  />
                </Col>
                <Col xs={2} className="justify-content-center">
                  <InputNumber
                    // type="number"
                    className="modal-text"
                    value={item.counter}
                    // max={parseInt(item.max_qty)}
                    onChange={(e) => {
                      setOrderItems((prev) => {
                        const updatedOptions = [...prev];
                        updatedOptions[index] = {
                          ...updatedOptions[index],
                          counter: e,
                        };
                        return updatedOptions;
                      });
                      if (
                        parseInt(e) > 0 &&
                        parseInt(e) <= parseInt(item.max_qty)
                      ) {
                        setItemsToVoid([...itemsToVoid, item.id]);
                      } else {
                        const newItems = itemsToVoid.filter(
                          (data) => data !== item.id
                        );
                        setItemsToVoid(newItems);
                      }
                    }}
                  />
                </Col>
                <Col xs={1}>
                  <PlusCircleFilled
                    className="modal-icon"
                    onClick={() => {
                      setItemsToVoid([...itemsToVoid, item.id]);
                      setOrderItems((prev) => {
                        const updatedOptions = [...prev];
                        if (
                          parseInt(updatedOptions[index].counter) + 1 <=
                          parseInt(updatedOptions[index].max_qty)
                        ) {
                          updatedOptions[index] = {
                            ...updatedOptions[index],
                            counter:
                              parseInt(updatedOptions[index].counter) + 1,
                          };
                        } else if (
                          parseInt(updatedOptions[index].counter) ===
                          parseInt(updatedOptions[index].max_qty)
                        ) {
                          // do nothing but don't remove this condition
                        } else {
                          const newArray = itemsToVoid.filter(
                            (voidItem) => voidItem !== item.id
                          );
                          setItemsToVoid(newArray);
                        }
                        return updatedOptions;
                      });
                    }}
                  />
                </Col>
                <Col xs={2}>
                  <Checkbox
                    className="modal-checkbox"
                    checked={itemsToVoid.includes(item.id)}
                    onChange={(e) => {
                      if (
                        e.target.checked &&
                        parseInt(item.counter) > 0 &&
                        parseInt(item.counter) <= parseInt(item.max_qty)
                      ) {
                        setItemsToVoid([...itemsToVoid, item.id]);
                      } else {
                        const newArray = itemsToVoid.filter(
                          (voidItem) => voidItem !== item.id
                        );
                        setItemsToVoid(newArray);
                      }
                    }}
                  />
                </Col>
              </Row>
            ))}
            {itemsToVoid.length > 0 && (
              <>
                <Title level={5} className="mt-5">
                  CHOOSE TABLE
                </Title>
                <Row>
                  {allTables[priceType]?.map((table, index) => {
                    if (
                      table.status === "inactive" ||
                      (table.status === "active" &&
                        table.id !== selectedTable.id &&
                        !mergedTables.includes(table.id) &&
                        table.order_status !== "billed")
                    ) {
                      return (
                        <Col
                          key={index}
                          lg={6}
                          xs={12}
                          className={`mt-3 table-cards ${
                            table.id === recipientTable.table_id
                              ? ""
                              : "taken-table-card"
                          }`}
                          onClick={() => {
                            if (table.id === recipientTable.table_id) {
                              // do nothing to the selected table to merge
                            } else {
                              setRecipientTable({
                                table_id: table.id,
                                table_no: table.table_no,
                              });
                            }
                          }}
                        >
                          {table.status === "active" &&
                          table.order_status !== "billed" ? (
                            <Badge.Ribbon
                              text="OCCUPIED"
                              color="red"
                              placement="start"
                            >
                              <Card className={`${priceType}-clicked`}>
                                <Title level={3}>{table.table_no}</Title>
                              </Card>
                            </Badge.Ribbon>
                          ) : table.status === "active" &&
                            table.order_status === "billed" ? (
                            <Badge.Ribbon
                              text="BILLED"
                              color="cyan"
                              placement="start"
                            >
                              <Card className={`${priceType}-clicked`}>
                                <Title level={3}>{table.table_no}</Title>
                              </Card>
                            </Badge.Ribbon>
                          ) : (
                            <Card className={`${priceType}-clicked`}>
                              <Title level={3}>{table.table_no}</Title>
                            </Card>
                          )}
                        </Col>
                      );
                    }
                  })}
                </Row>
              </>
            )}
          </>
        )}

        <hr />
        <Space className="d-flex justify-content-end w-100 p-0 mt-3">
          <Button
            className="me-2 px-4 py-3"
            onClick={() => {
              recordUserActivityLog(
                `Clicked cancel to transfer table ${selectedTable.table_no}`
              );
              handleRemoveActiveAttending({isRefresh: true});
              // handleAttendingTransfer(localAttendingTransfer, true)
              setRecipientTable({});
              setOpenTransferModal(false);
              setOpenTransferItemOptions(false);
              setOpenTransferTableOptions(false);
            }}
          >
            CANCEL
          </Button>
          {openTransferTableOptions && (
            <Button
              type="primary"
              className="px-4 py-3"
              onClick={handleTransferTable}
              disabled={!recipientTable.table_id}
            >
              TRANSFER
            </Button>
          )}
          {openTransferItemOptions && (
            <Button
              type="primary"
              className="px-4 py-3"
              onClick={handleTransferItems}
              disabled={itemsToVoid.length === 0 || itemsToVoid.length === 0}
            >
              TRANSFER
            </Button>
          )}
        </Space>
      </Modal>

      {/* TAKEOUT CUSTOMER DETAILS MODAL */}
      <Modal
        maskClosable={false}
        open={showCustomerModal}
        closeIcon={false}
        footer={null}
        centered
        width={800}
        title="Customer Details"
      >
        <Form layout="vertical">
          <Row>
            <Col xs={12}>
              <Form.Item label="Name">
                <Input
                  placeholder="Ex: Juan Dela Cruz"
                  onChange={(e) =>
                    setTakeoutCustomerDetails((prev) => ({
                      ...prev,
                      name: e.target.value,
                    }))
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={12}>
              <Form.Item label="Contact No.">
                <Input
                  type="number"
                  placeholder="Ex: 09123456789"
                  onChange={(e) =>
                    setTakeoutCustomerDetails((prev) => ({
                      ...prev,
                      contact_no: e.target.value,
                    }))
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <hr />
        <Space className="d-flex justify-content-end w-100 p-0 mt-3">
          <Button
            className="me-2 px-4 py-3"
            onClick={() => {
              if (selectedTable.status === "inactive") {
                handleTableActivation(selectedTable, "inactive");
              }
              setShowCustomerModal(false);
              setTakeoutCustomerDetails({});
              setDisableTableClick(false);
            }}
          >
            CANCEL
          </Button>
          <Button
            type="primary"
            className="px-4 py-3"
            onClick={() => {
              setShowCustomerModal(false);
              handleProductShow(true);
              setDisableTableClick(false);
            }}
            disabled={
              !takeoutCustomerDetails.name ||
              takeoutCustomerDetails.name === "" ||
              !validateContactNumber(takeoutCustomerDetails.contact_no)
            }
          >
            PROCEED
          </Button>
        </Space>
      </Modal>

      {/* ADD REMARKS PER ORDERED ITEM */}
      <Modal
        maskClosable={false}
        open={openRemarksModal}
        onCancel={() => setOpenRemarksModal(false)}
        closeIcon={false}
        footer={null}
        centered
        title="Item Remarks"
      >
        <TextArea
          value={tempRemarks}
          placeholder="Enter remarks"
          onChange={(e) => {
            setTempRemarks(e.target.value);
          }}
        />
        <Space className="d-flex justify-content-end w-100 p-0 mt-4">
          <Button
            className="me-2 px-4 py-3"
            onClick={() => {
              if (selectedTable.status === "inactive") {
                handleTableActivation(selectedTable, "inactive");
              }
              setOpenRemarksModal(false);
            }}
          >
            CANCEL
          </Button>
          <Button
            type="primary"
            className="px-4 py-3"
            onClick={() => {
              const newOrderCart = [...orderCart];
              newOrderCart[orderCartIndex].remarks = tempRemarks;
              setOrderCart(newOrderCart);

              if (localShowAddItem) {
                const newAddition = [...additionalItems];
                const newItemIndex = newAddition.findIndex(
                  (item) => item.id === newOrderCart[orderCartIndex].id
                );
                newAddition[newItemIndex]["remarks"] = tempRemarks;
                setAdditionalItems(newAddition);
              }

              setOpenRemarksModal(false);
            }}
          >
            SAVE
          </Button>
        </Space>
      </Modal>

      <Modal
        open={openModifier}
        onCancel={() => {
            setOpenModifier(false);
          }
        }
        closeIcon={false}
        footer={null}
        maskClosable={false}
        className="modifier-modal"
      >
        <Row className="mb-4">
          <Col span={12} className="modifier-title">
            Select Modifier
          </Col>
          <Col span={12} align="end">
            <Row align="end">
              <Col align="end" xs={8} className="text-center vertical-center">
                <MinusCircleFilled
                  onClick={() =>
                    handleModifierOrder("minus")
                  }
                  className={`modifier-icon ${priceType}-icon`}
                />
              </Col>
              <Col xs={8} className="text-center">
                <Input
                  className="modifier-input-field text-center"
                  value={modifierOrder.counter}
                  onChange={(e) =>
                    handleModifierOrder("input", e)
                  }
                />
              </Col>
              <Col xs={8} className="text-center vertical-center">
                <PlusCircleFilled
                  onClick={() =>
                    handleModifierOrder("add")
                  }                  
                  className={`modifier-icon ${priceType}-icon`}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          {
            modifierData?.addons?.map((data) => (
              <Col span={6}>
                <input
                  id={data?.id}
                  class="checkbox-custom"
                  name={data?.modifier_name}
                  value={data?.id}
                  type="checkbox"
                  onChange={(e) => handleModifierOrder("addons", e, data)}
                  checked={modifierOrder?.modifier?.some(item => item.modifier_id === data?.modifier_id)}
                  disabled={modifierOrder?.modifier?.some(item => item.modifier_id !== data?.modifier_id)}
                />
                <label for={data?.id} class="checkbox-custom-label">
                  {data?.modifier_name.toUpperCase()}
                </label>
              </Col>
            ))
          }
        </Row>
        <Space className="d-flex justify-content-end w-100 p-0 mt-4">
          <Button
            className="me-2 px-4 py-3"
            onClick={() => {
              setOpenModifier(false);
            }}
          >
            CANCEL
          </Button>
          <Button
            type="primary"
            className="px-4 py-3"
            disabled={modifierOrder && parseInt(modifierOrder?.counter) === 0}
            onClick={() => {
              handleAddModifierOrder()
              // setOpenModifier(false);
            }}
          >
            ADD
          </Button>
        </Space>
      </Modal>

      <Modal
        maskClosable={false}
        open={openPaxErrorCountModal}
        footer={null}
        closeIcon={false}
      >
        <Row className="d-flex justify-content-center">
          <Title level={3}>TABLE ALREADY TAKEN!</Title>
        </Row>
        <Row>
          <Col span={24} align='right'>
            <Button
              type="primary"
              onClick={() => {
                setOpenPaxErrorCountModal(false);
                handleRemoveProduct();
                refreshPage();
              }}
            >
              CANCEL
            </Button>
          </Col>
        </Row>
      </Modal>

      {/* MODAL FOR PRINTER LOADER */}
      <Modal
        maskClosable={false}
        open={printingInProgress}
        footer={null}
        closeIcon={false}
      >
        <Row className="d-flex justify-content-center">
          <Title level={5}>PRINTING IN PROGRESS</Title>
        </Row>
        <Row className="d-flex justify-content-center mt-3">
          <Spin size="large" />
        </Row>
        <Row className="d-flex justify-content-center mt-3">
          Please do not close this window.
        </Row>
      </Modal>

      <div className="">{renderOrderSlips()}</div>
      <div className="">{renderCancelSlips()}</div>
      <div className="">{renderVoidSlips()}</div>

      <div className="hide-from-screen">
        <div ref={cancelRef}>
          <div className="d-flex justify-content-center">
            <DispatchSlip
              includeItemRemarks
              purpose="cancel"
              additionalItems={[]}
              table={selectedTable.table_no}
              orderItems={orderCart}
              restoType={loggedInResto}
              setBulkPrintRef={() => {}}
            />
          </div>
        </div>

        <div ref={voidRef}>
          <div className="d-flex justify-content-center">
            <DispatchSlip
              includeItemRemarks
              purpose="void"
              additionalItems={[]}
              table={selectedTable.table_no}
              orderItems={voidedItems}
              restoType={loggedInResto}
              setBulkPrintRef={() => {}}
            />
          </div>
        </div>

        <div ref={transferRef}>
          <div className="d-flex justify-content-center">
            <DispatchSlip
              purpose="transfer"
              table={selectedTable.table_no}
              tableTo={recipientTable.table_no}
              additionalItems={[]}
              orderItems={orderCart}
              restoType={loggedInResto}
            />
          </div>
        </div>

        <div ref={splitRef}>
          <div className="d-flex justify-content-center">
            <DispatchSlip
              purpose="split"
              table={selectedTable.table_no}
              additionalItems={[]}
              orderItems={voidedItems}
              restoType={loggedInResto}
            />
          </div>
        </div>

        {/* <div ref={dispatchRef}>
          <div className="d-flex justify-content-center">
            <DispatchSlip
              includeItemRemarks
              purpose="dispatch"
              additionalItems={noBarAdditionalItems}
              // additionalItems={dispatchItems}
              voidedItems={voidedItems}
              table={selectedTable.table_no}
              orderItems={dispatchItems}
              restoType={loggedInResto}
              pageAction={action}
              // foodServer={foodServer}
              dispatchCounter={dispatchCounter}
            />
          </div>
        </div> */}
      </div>
      {contextHolder}
    </div>
  );
}
